import React, { Component } from 'react';
import { HTTPService } from "./../../../services/httpService";
import BootstrapTable from 'react-bootstrap-table-next';
import "react-bootstrap-table/css/react-bootstrap-table.css";
import moment from 'moment';
import _ from 'lodash';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {ViewJob} from '../requestimates/displayJob';
import {AddPO} from '../../partial/addPO';
import {BatchCheckPayment} from './BatchCheckPayment';
import DealerGroupService from '../../../services/dealerGroupService';
import { isInstallerAdmin } from '../../../util/permissions';
import ScopeService from '../../../services/scopeService';
import QboAPI from '../../../services/qboService';
import { convertFromUTC } from '../../../util/convert_timezone';
import { isMultiLocation, isAllLocations, getLocationName, getLocationBadgeColor, isAllDealerships, ALL_DEALERSHIPS_ID } from '../../../util/locationUtils';

require('dotenv').config();

const API = new HTTPService();

// Constants to match calendar styling
const DESKTOP_BREAKPOINT = 1024;

// Payment-state predicates. The server stores two distinct success states:
//   'paid'    — Stripe-flowed payment (card / link / bank)
//   'settled' — offline payment recorded via /installerPaymentSettle (cash/check)
// Both indicate the money came in. Treat them equivalently for totals, paid-date,
// and filtering. For the displayed label we still differentiate so users can tell
// at a glance whether the payment ran through Stripe ("Paid - Card") or was
// recorded offline ("Cash" / "Check #1234").
const isPaidLike = (state) => state === 'paid' || state === 'settled';

// A voided invoice is retained as an audit record (request + installer_payment are
// soft-marked, not deleted) but is excluded from every list and from all totals
// unless the user explicitly selects the "Voided" state filter.
const isVoidedLike = (state) => state === 'voided' || state === 'void';

// Build the user-facing state label for the report's "State" column.
const formatPaymentStateLabel = (job, effectivePayoutId) => {
  const state = job.payment_state;
  const method = job.payment_method;
  if (state === 'paid' && method) {
    const hasCheckNumber = effectivePayoutId && !String(effectivePayoutId).startsWith('po_');
    return hasCheckNumber
      ? `Paid - ${_.capitalize(method)} #${effectivePayoutId}`
      : `Paid - ${_.capitalize(method)}`;
  }
  if (state === 'settled' && method) {
    // Offline payment — surface the actual method (Cash / Check / etc.) instead
    // of the internal 'settled' state. Append the check number when present.
    const hasCheckNumber = effectivePayoutId && !String(effectivePayoutId).startsWith('po_');
    return hasCheckNumber
      ? `${_.capitalize(method)} #${effectivePayoutId}`
      : _.capitalize(method);
  }
  return state ? _.capitalize(state) : '';
};

class Financials extends Component {
    state = { 
        typeId : this.props.typeId,
        transactions : [],
        notPaid : [],
        offers : [],
        requests : [],
        estimates : [],
        services : [],
        owed : 0,
        pending : 0,
        earned : 0,
        selectedDate : {},
        today : "",
        thisDay : "",
        thisWeek : "",
        thisMonth : "",
        selectedWeek : "",
        selectedMonth : "",
        startDate : "",
        duration : 0,
        range : "month",
        displayString : "",
        showDetails : false,
        selectedRequestimate : {},
        notes : {},
        showPO : false,
        // Revise/void choice modal (Void & Replace vs Void Only)
        showReviseChoice : false,
        reviseRow : null,
        reviseBusy : false,
        options : ["All States", "Invoiced", "Paid", "Voided"],
        selectedOption : "All States",
        types : ["All Types", "Dealer", "Retail"],
        selectedType : "All Types",
        requestId : "",
        poNummber : "",
        invoiceId : "",
        // Search functionality
        searchTerm: "",
        filteredTransactions: [],
        showSearchResults: false,
        // Name filter
        nameSearchTerm: "",
        filteredByName: [],
        showNameFilter: false,
        // VIN filter
        vinSearchTerm: "",
        filteredByVin: [],
        showVinFilter: false,
        // Responsive state
        isDesktop: window.innerWidth >= DESKTOP_BREAKPOINT,
        error: null,
        loading: false,
        stripeDashboardLoading: false,
        canAccessStripeDashboard: false,
        // Custom date range state
        customStartDate: "",
        customEndDate: "",
        showCustomInputs: false,
        batchCheckMode: false,
        selectedInvoices: [],
        showBatchCheck: false,
        // Split payment expanded rows
        expandedRows: [],
        // Dealer group state
        dealerships: [],
        selectedDealerId: isAllDealerships(this.props.selectedDealerId)
            ? ALL_DEALERSHIPS_ID
            : this.props.selectedDealerId,
        selectedInstallerId: "all",
        installers: [],
        // Location filter (independent from global selector)
        financialsLocationId: null,
        // Installer-side dealer group filter
        dealerGroups: [],
        selectedDealerGroupId: "all",
        selectedDealerGroupDealerId: "all",
        // QuickBooks sync
        qboConnected: false,
        qboSyncing: false,
    };
  
    async componentDidMount() {
        console.log("Financials : componentDidMount :", this.props.user);
        try {
            let transactions = [];

            if (this.props.userType === "dealer" && ScopeService.isDealerGroupUser()) {
                // Dealer group: fetch aggregated payments (scoped if specific dealer selected)
                const dealerships = await DealerGroupService.getDealerships(this.props.groupId);
                const scopedDealerId = isAllDealerships(this.props.selectedDealerId)
                    ? null : this.props.selectedDealerId;
                transactions = await DealerGroupService.getGroupPayments(this.props.groupId, scopedDealerId);

                // Extract unique installer names from transactions
                // Server returns installer name as 'Name' (capital N, aliased from installer_name)
                const installerNames = [...new Set(
                    transactions
                        .map(tx => tx.installer_name || tx.specialist_name || tx.Name)
                        .filter(Boolean)
                )].sort();

                this.setState({ dealerships, installers: installerNames });
            } else {
                // Single installer or dealer
                let financialsRequest = `/installerPayments/${this.state.typeId}`;
                if (this.props.userType === "dealer"){
                    financialsRequest = `/dealerPayments/${this.state.typeId}`;
                }
                const locationId = this.state.financialsLocationId || this.props.selectedLocationId || null;
                if (locationId && locationId !== 'all') {
                    financialsRequest += `?locationId=${locationId}`;
                }
                const response = await API.get(financialsRequest);
                transactions = response.data;
            }

            // Convert all "covered" states to "invoiced"
            transactions.forEach((element, index, array) => {
                if (element.payment_state  === "covered") {
                    array[index].payment_state = "invoiced";
                }
            });

            // Collapse server-side duplicate rows (e.g. join artifacts).
            transactions = this.dedupeTransactions(transactions);

console.log("Financials : componentDidMount : transactions :", transactions);

            // Installer view: extract dealer groups with their dealerships from transactions
            if (this.props.userType === "installer") {
                const groupMap = {};
                transactions.forEach(tx => {
                    if (tx.dealer_group_id != null && tx.dealer_group_name) {
                        if (!groupMap[tx.dealer_group_id]) {
                            groupMap[tx.dealer_group_id] = {
                                group_id: tx.dealer_group_id,
                                group_name: tx.dealer_group_name,
                                dealerships: {}
                            };
                        }
                        // Track dealerships within each group
                        // Server returns dealer name as Name (CASE expression) for dealer-type requests
                        const dealerName = tx.dealer_name || (tx.Request_type === 'dealer' ? tx.Name : null);
                        if (tx.dealer_id != null && dealerName) {
                            groupMap[tx.dealer_group_id].dealerships[tx.dealer_id] = dealerName;
                        }
                    }
                });
                const dealerGroups = Object.values(groupMap).map(g => ({
                    group_id: g.group_id,
                    group_name: g.group_name,
                    dealerships: Object.entries(g.dealerships)
                        .map(([id, name]) => ({ dealer_id: id, dealer_name: name }))
                        .sort((a, b) => a.dealer_name.localeCompare(b.dealer_name))
                })).sort((a, b) => a.group_name.localeCompare(b.group_name));

                if (dealerGroups.length > 0) {
                    // If a group has only one dealership, auto-select it
                    const autoState = {};
                    if (dealerGroups.length === 1 && dealerGroups[0].dealerships.length === 1) {
                        autoState.selectedDealerGroupId = String(dealerGroups[0].group_id);
                        autoState.selectedDealerGroupDealerId = String(dealerGroups[0].dealerships[0].dealer_id);
                    }
                    this.setState({ dealerGroups, ...autoState });
                }
            }

            this.setState({ transactions });

            var today = moment();
            const startDate = moment().startOf('month');
            const endDate   = moment().endOf('month');
            const duration = today.daysInMonth(); 
            var displayString = this.getDisplayString(startDate, "month");

            this.setState({ today, startDate, endDate, selectedDate : startDate, displayString, duration });

        } catch (error) {
            console.error('Error loading financial data:', error);
            this.setState({ 
                error: 'Failed to load financial data. Please refresh the page.' 
            });
        }
        
        this.checkStripeDashboardEligibility();
        this.checkQboConnection();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Add this method to your existing Financials component

handleGenerateBookkeeperReport = async () => {
    this.setState({ loading: true });

    try {
        const startDate = this.state.startDate.format('YYYY-MM-DD');
        const endDate = this.state.endDate.format('YYYY-MM-DD');
        const installerId = this.state.typeId;

        console.log('Preparing to generate bookkeeper report for:', { installerId, startDate, endDate });
        
        // Use the React environment variable for API URL
        const apiUrl = process.env.REACT_APP_API_URL || 'https://api.jobvious.com';
        const locationId = this.state.financialsLocationId || this.props.selectedLocationId || null;
        const locationParam = (locationId && locationId !== 'all') ? `&locationId=${locationId}` : '';
        const reportUrl = `${apiUrl}/bookkeeper-report/${installerId}?startDate=${startDate}&endDate=${endDate}&format=html${locationParam}`;
        
        console.log('Generating bookkeeper report with URL:', reportUrl);
        
        // Open the HTML report in a new window
        const reportWindow = window.open(reportUrl, '_blank', 'width=1200,height=800,scrollbars=yes,resizable=yes');
        
        if (!reportWindow) {
            window.open(reportUrl, '_blank');
        }
        
        this.setState({ loading: false });
        
    } catch (error) {
        console.error('Error generating bookkeeper report:', error);
        alert('Error generating bookkeeper report. Please try again.');
        this.setState({ loading: false });
    }
};

    checkStripeDashboardEligibility = () => {
        if (this.props.userType !== "installer") {
            this.setState({ canAccessStripeDashboard: false });
            return;
        }

        const userEmail = this.props.user?.Email;
        const installerEmail = this.props.company?.installer_email;
        
        if (!userEmail || !installerEmail) {
            console.warn('Missing email data for Stripe dashboard check', {
                hasUserEmail: !!userEmail,
                hasInstallerEmail: !!installerEmail
            });
            this.setState({ canAccessStripeDashboard: false });
            return;
        }

        const emailsMatch = userEmail.toLowerCase() === installerEmail.toLowerCase();
        
        if (emailsMatch) {
            this.setState({ canAccessStripeDashboard: true });
        } else {
            console.warn('Email mismatch - User cannot access Stripe dashboard', {
                userEmail,
                installerEmail
            });
            this.setState({ canAccessStripeDashboard: false });
        }
    };

    checkQboConnection = async () => {
        if (this.props.userType !== 'installer' || !isInstallerAdmin(this.props.user)) return;
        if (this.props.company?.qb_mode !== 'online') return;
        try {
            const qbo = await QboAPI.getConnection(this.state.typeId);
            this.setState({ qboConnected: !!(qbo && qbo.enabled && qbo.connected && !qbo.token_expired) });
        } catch (e) {
            // QBO not set up — leave as false
        }
    };

    getUnsyncedPayments = (displayArray) => {
        return displayArray.filter(row =>
            row.currentState === 'Paid' && !row.qbo_invoice_id
        );
    };

    handleQboSync = async (displayArray) => {
        const unsynced = this.getUnsyncedPayments(displayArray);
        if (unsynced.length === 0) return;

        this.setState({ qboSyncing: true });

        const BATCH_SIZE = 5;
        let successCount = 0;
        let errorCount = 0;
        let authError = false;

        for (let i = 0; i < unsynced.length; i += BATCH_SIZE) {
            const batch = unsynced.slice(i, i + BATCH_SIZE);

            const results = await Promise.allSettled(
                batch.map(async (row) => {
                    await QboAPI.syncPayment(row.invoiceId);
                    await new Promise(resolve => setTimeout(resolve, 200));
                })
            );

            for (const result of results) {
                if (result.status === 'fulfilled') {
                    successCount++;
                } else {
                    const error = result.reason;
                    if (error.response?.status === 401 ||
                        error.message?.includes('expired') ||
                        error.message?.includes('invalid_grant')) {
                        authError = true;
                    }
                    errorCount++;
                }
            }

            if (authError) break;

            if (i + BATCH_SIZE < unsynced.length) {
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
        }

        this.setState({ qboSyncing: false });

        if (authError) {
            this.setState({ qboConnected: false });
            alert('Your QuickBooks connection has expired. Please reconnect from your Profile page.');
            return;
        }

        let msg = `QuickBooks sync complete!\n\n✅ Synced: ${successCount}`;
        if (errorCount > 0) {
            msg += `\n❌ Failed: ${errorCount}\n\nFailed records can be retried by syncing again.`;
        }
        alert(msg);

        // Refresh financial data
        await this.refreshFinancialData();
    };

    handleQboRetrySingle = async (invoiceId) => {
        try {
            await QboAPI.syncPayment(invoiceId);
            await this.refreshFinancialData();
        } catch (error) {
            if (error.response?.status === 401) {
                this.setState({ qboConnected: false });
                alert('Your QuickBooks connection has expired. Please reconnect from your Profile page.');
            } else {
                alert('Sync failed. Please try again.');
            }
        }
    };

    refreshFinancialData = async () => {
        try {
            let transactions;
            if (this.props.userType === "dealer" && ScopeService.isDealerGroupUser()) {
                // Dealer group: re-aggregate across the group (scoped if a specific dealer
                // is selected), matching the mount-time fetch. Without this branch a refresh
                // (e.g. after a QuickBooks single-retry) silently reverted the aggregated
                // group view to only the first dealership's payments.
                const scopedDealerId = isAllDealerships(this.props.selectedDealerId)
                    ? null : this.props.selectedDealerId;
                transactions = await DealerGroupService.getGroupPayments(this.props.groupId, scopedDealerId);
            } else {
                let financialsRequest = `/installerPayments/${this.state.typeId}`;
                if (this.props.userType === "dealer") {
                    financialsRequest = `/dealerPayments/${this.state.typeId}`;
                }
                const locationId = this.state.financialsLocationId || this.props.selectedLocationId || null;
                if (locationId && locationId !== 'all') {
                    financialsRequest += `?locationId=${locationId}`;
                }
                const response = await API.get(financialsRequest);
                transactions = response.data;
            }
            transactions.forEach((element, index, array) => {
                if (element.payment_state === "covered") {
                    array[index].payment_state = "invoiced";
                }
            });
            transactions = this.dedupeTransactions(transactions);
            this.setState({ transactions });
        } catch (error) {
            console.error('Error refreshing financial data:', error);
        }
    };

    handleResize = () => {
        this.setState({ isDesktop: window.innerWidth >= DESKTOP_BREAKPOINT });
    };

    // Dedupe transactions returned from the server. Server-side joins can produce
    // identical duplicate rows (same invoice + same request + same payment_type);
    // we collapse those to a single row. Legitimate splits (e.g. deposit + final
    // for the same invoice, which differ by payment_type) are preserved.
    dedupeTransactions = (transactions) => {
        if (!Array.isArray(transactions)) return transactions;
        return _.uniqBy(transactions, (t) =>
            [
                t.invoice_id || t.stripe_invoice || '',
                t.request_id || '',
                t.payment_type || '',
            ].join('|')
        );
    };

    handleFinancialsLocationChange = (locationId) => {
        this.setState({ financialsLocationId: locationId }, async () => {
            try {
                let transactions;
                if (this.props.userType === "dealer" && ScopeService.isDealerGroupUser()) {
                    // Dealer group: keep the aggregated group view (scoped if a specific
                    // dealer is selected). Group payments aren't location-scoped, so the
                    // location filter doesn't apply here — but we must NOT drop back to the
                    // first dealership's /dealerPayments, which is what happened before.
                    const scopedDealerId = isAllDealerships(this.props.selectedDealerId)
                        ? null : this.props.selectedDealerId;
                    transactions = await DealerGroupService.getGroupPayments(this.props.groupId, scopedDealerId);
                } else {
                    let financialsRequest = `/installerPayments/${this.state.typeId}`;
                    if (this.props.userType === "dealer") {
                        financialsRequest = `/dealerPayments/${this.state.typeId}`;
                    }
                    const locId = this.state.financialsLocationId || this.props.selectedLocationId || null;
                    if (locId && locId !== 'all') {
                        financialsRequest += `?locationId=${locId}`;
                    }
                    const response = await API.get(financialsRequest);
                    transactions = response.data;
                }
                transactions.forEach((element, index, array) => {
                    if (element.payment_state === "covered") {
                        array[index].payment_state = "invoiced";
                    }
                });
                transactions = this.dedupeTransactions(transactions);
                this.setState({ transactions });
            } catch (error) {
                console.error('Error reloading financials:', error);
            }
        });
    };

    handleStripeDashboard = async () => {
        if (this.props.userType !== "installer") {
            alert("Stripe dashboard is only available for specialists.");
            return;
        }

        const userEmail = this.props.user?.Email;
        const installerEmail = this.props.company?.installer_email;
        
        if (!userEmail || !installerEmail || userEmail.toLowerCase() !== installerEmail.toLowerCase()) {
            alert("Dashboard access denied - your login email does not match the account email. Please contact support.");
            return;
        }

        this.setState({ stripeDashboardLoading: true });

        try {
            const response = await API.get(`/stripe/dashboard/${this.state.typeId}`);
            
            if (response.data.url) {
                window.open(response.data.url, '_blank');
            } else {
                alert('Unable to access Stripe dashboard. Please contact support.');
            }
        } catch (error) {
            console.error('Error accessing Stripe dashboard:', error);
            if (error.response && error.response.status === 404) {
                alert('No payment account found. Please set up your payment account first.');
            } else {
                alert('Unable to access Stripe dashboard. Please try again later.');
            }
        } finally {
            this.setState({ stripeDashboardLoading: false });
        }
    };

    getDisplayString = (date, range, invoiceCount = 0) => {
        let dateString = "";
        if (range === "day") {
            dateString = date.format("ddd, MMM Do YYYY");
        } else if (range === "week") {
            const startOfWeek = moment(date).startOf("week");
            const endOfWeek = moment(date).endOf("week");
            dateString = startOfWeek.format("MMM Do") + " - " + endOfWeek.format("MMM Do, YYYY");
        } else if (range === "month") {
            const startOfMonth = moment(date).startOf("month");
            const endOfMonth = moment(date).endOf("month");
            dateString = startOfMonth.format("MMM Do") + " - " + endOfMonth.format("MMM Do, YYYY");
        } else if (range === "custom") {
            const startDate = this.state.startDate || date;
            const endDate = this.state.endDate || date;
            dateString = startDate.format("MMM Do, YYYY") + " - " + endDate.format("MMM Do, YYYY");
        } else {
            dateString = date.format("ddd, MMM Do YYYY");
        }
        
        return dateString;
    };

    handleSelect = (event) => {
        const {value} = event.currentTarget;
        this.setState( {selectedTime : value });
    };

    handleTypeChange = (event) => {
        const {value} = event.currentTarget;
        this.setState( {selectedType : value });
    };

    handleDealerFilterChange = (event) => {
        this.setState({ selectedDealerId: event.currentTarget.value });
    };

    handleInstallerFilterChange = (event) => {
        this.setState({ selectedInstallerId: event.currentTarget.value });
    };

    handleDealerGroupFilterChange = (event) => {
        const value = event.currentTarget.value;
        // Value format: "all", "group:{id}", or "dealer:{groupId}:{dealerId}"
        if (value === "all") {
            this.setState({ selectedDealerGroupId: "all", selectedDealerGroupDealerId: "all" });
        } else if (value.startsWith("group:")) {
            const groupId = value.replace("group:", "");
            this.setState({ selectedDealerGroupId: groupId, selectedDealerGroupDealerId: "all" });
        } else if (value.startsWith("dealer:")) {
            const parts = value.split(":");
            this.setState({ selectedDealerGroupId: parts[1], selectedDealerGroupDealerId: parts[2] });
        }
    };

    // Pen-icon entry point — open the choice modal instead of acting immediately.
    // The user picks "Void & Replace" (void + edit to regenerate) or "Void Only"
    // (void and keep the job as a retained, voided record).
    handleReviseInvoice = (row) => {
        this.setState({ showReviseChoice: true, reviseRow: row });
    };

    closeReviseChoice = () => {
        if (this.state.reviseBusy) return;
        this.setState({ showReviseChoice: false, reviseRow: null });
    };

    // Shared void routine. Soft-voids the invoice at the Stripe + request +
    // installer_payment level (server owns the record-keeping — we no longer
    // delete the payment row or null the invoiceId). Returns true on success.
    // `intent` is 'cancel' (Void Only) or 'replace' (Void & Replace); `reasonCode`
    // records why. Actor is derived server-side from the token — we send no user id.
    voidInvoice = async (row, intent = 'cancel', reasonCode = 'unspecified') => {
        let step = 'load invoice';
        try {
            const { data: invoice } = await API.get(`/invoices/${row.invoiceId}`);

            step = 'void invoice in Stripe';
            // Drafts can't be voided in Stripe (must be deleted); finalized invoices
            // are voided. In both cases the server soft-marks the request and
            // installer_payment rows as voided so the audit record is retained.
            const { data: voidResult } = invoice.status === 'draft'
                ? await API.delete(`/invoices/${row.invoiceId}`)
                : await API.put(`/invoices/void/${row.invoiceId}`, { intent, reasonCode, reasonNotes: null });

            if (voidResult?.qbo === 'failed') {
                alert(
                    `Invoice voided in Stripe, but the QuickBooks entry was not removed.\n\n` +
                    `${voidResult.qboError || 'Unknown QuickBooks error.'}\n\n` +
                    `Please void the QuickBooks entry manually.`
                );
            }
            return true;
        } catch (error) {
            const serverMsg = error?.response?.data?.message || error?.response?.data?.error || error.message;
            console.error(`Void failed at "${step}":`, error?.response?.status, error?.response?.data, error);
            alert(`Unable to ${step}.\n\n${serverMsg}\n\nPlease try again or contact support.`);
            return false;
        }
    };

    // Void & Replace — void the invoice, then go edit the job so a replacement
    // invoice can be generated.
    handleVoidAndReplace = async () => {
        const row = this.state.reviseRow;
        if (!row) return;
        this.setState({ reviseBusy: true });
        const ok = await this.voidInvoice(row, 'replace', 'invoice_correction');
        if (!ok) {
            this.setState({ reviseBusy: false });
            return;
        }
        window.location = `/editJob/${row.requestId}`;
    };

    // Void Only — void the invoice and leave the job as a retained, voided record.
    // No replacement is created; the row drops out of the active lists.
    handleVoidOnly = async () => {
        const row = this.state.reviseRow;
        if (!row) return;
        this.setState({ reviseBusy: true });
        const ok = await this.voidInvoice(row, 'cancel', 'canceled_no_replace');
        if (!ok) {
            this.setState({ reviseBusy: false });
            return;
        }
        this.setState({ showReviseChoice: false, reviseRow: null, reviseBusy: false });
        await this.refreshFinancialData();
    };

    handleOpenInvoice = async (invoiceId) => {
        if (!invoiceId) {
            alert("No invoice ID available");
            return;
        }
        try {
            const { data } = await API.get(`/invoices/${invoiceId}/fresh-url`);
            if (data.success && data.hosted_invoice_url) {
                window.open(data.hosted_invoice_url, '_blank');
            } else {
                alert("Unable to open invoice. Please try again.");
            }
        } catch (error) {
            console.error("Error fetching fresh invoice URL:", error);
            alert("Unable to open invoice. Please try again.");
        }
    };

    // Resend an open/invoiced invoice — server re-sends using current values
    // (e.g. an updated billing email), which is sometimes necessary.
    handleResendInvoice = async (invoiceId) => {
        if (!invoiceId) {
            alert("No invoice ID available to resend.");
            return;
        }
        try {
            await API.put(`/invoices/resend/${invoiceId}`);
            alert("Invoice resent.");
        } catch (error) {
            console.error("Error resending invoice:", error);
            alert("Unable to resend the invoice. Please try again.");
        }
    };

    handleOptionChange = (event) => {
        const {value} = event.currentTarget;
        this.setState( {selectedOption : value });
    };

    handleSearchChange = (event) => {
        const { value } = event.currentTarget;
        
        if (!value.trim()) {
            this.clearSearch();
            return;
        }
        
        this.setState({ searchTerm: value });
        
        const lowercasedValue = value.toLowerCase().trim();
        const filtered = this.state.transactions.filter(item =>
            (item.stripe_invoice && item.stripe_invoice.toLowerCase().includes(lowercasedValue)) ||
            (item.invoice_id && item.invoice_id.toLowerCase().includes(lowercasedValue))
        );
        
        this.setState({ 
            filteredTransactions: filtered,
            showSearchResults: true
        });
    };

    handleNameSearchChange = (event) => {
        const { value } = event.currentTarget;
        
        if (!value.trim()) {
            this.clearNameFilter();
            return;
        }
        
        this.setState({ nameSearchTerm: value });
        
        const lowercasedValue = value.toLowerCase().trim();
        const filtered = this.state.transactions.filter(item => 
            item.Name && item.Name.toLowerCase().includes(lowercasedValue)
        );
        
        this.setState({ 
            filteredByName: filtered,
            showNameFilter: true
        });
    };

    handleNameSelect = (selectedName) => {
        this.setState({ 
            nameSearchTerm: selectedName,
            filteredByName: this.state.transactions.filter(
                item => item.Name === selectedName
            ),
            showNameFilter: true
        });
    };

    clearNameFilter = () => {
        this.setState({
            nameSearchTerm: "",
            filteredByName: [],
            showNameFilter: false
        });
    };

    handleVinSearchChange = (event) => {
        const { value } = event.currentTarget;

        if (!value.trim()) {
            this.clearVinFilter();
            return;
        }

        this.setState({ vinSearchTerm: value });

        const lowercasedValue = value.toLowerCase().trim();
        const filtered = this.state.transactions.filter(item =>
            (item.VIN && item.VIN.toLowerCase().includes(lowercasedValue)) ||
            (item.vin && item.vin.toLowerCase().includes(lowercasedValue))
        );

        this.setState({
            filteredByVin: filtered,
            showVinFilter: true
        });
    };

    clearVinFilter = () => {
        this.setState({
            vinSearchTerm: "",
            filteredByVin: [],
            showVinFilter: false
        });
    };

    clearSearch = () => {
        this.setState({ 
            searchTerm: "", 
            filteredTransactions: [], 
            showSearchResults: false 
        });
    };

    hasUnsettledDeposits = (displayArray) => {
        if (this.props.userType !== "installer") return false;
        
        return displayArray.some(item => 
            item.isDeposit && 
            item.currentState === 'Invoiced'
        );
    };

    handleToggleSplitExpand = (rowId) => {
        const { expandedRows } = this.state;
        const isExpanded = expandedRows.includes(rowId);

        if (isExpanded) {
            this.setState({
                expandedRows: expandedRows.filter(id => id !== rowId)
            });
        } else {
            this.setState({
                expandedRows: [...expandedRows, rowId]
            });
        }
    };

    handleShowDepositInfo = () => {
        if (this.props.userType !== "installer") return;
        
        const allDeposits = this.getCurrentDisplayData().filter(item => item.isDeposit);
        const unsettledDeposits = allDeposits.filter(item => item.currentState === 'Invoiced');
        const settledDeposits = allDeposits.filter(item => item.currentState === 'Paid');
        
        if (allDeposits.length === 0) {
            alert('No deposit invoices found.');
            return;
        }
        
        let message = `💰 Deposit Summary:\n\n`;
        message += `Total Deposits: ${allDeposits.length}\n`;
        message += `✅ Settled: ${settledDeposits.length}\n`;
        message += `⏳ Pending: ${unsettledDeposits.length}\n\n`;
        
        if (unsettledDeposits.length > 0) {
            message += `Pending Deposits:\n`;
            const depositList = unsettledDeposits.map(dep => 
                `• ${dep.invoiceNumber} - ${this.formatCurrency(parseFloat(dep.amount))}`
            ).join('\n');
            message += depositList;
            message += `\n\nClick "Settle as Cash/Check" next to any pending deposit to mark it as paid.`;
        }
        
        alert(message);
    };

    handleSettleDeposit = async (invoiceId, amount, invoiceNumber) => {
        if (this.props.userType !== "installer") {
            alert("Only specialists can settle deposit invoices.");
            return;
        }
        
        const confirmMessage = `Settle deposit invoice ${invoiceNumber} for ${this.formatCurrency(parseFloat(amount))} as cash/check payment?\n\nThis will mark the deposit as paid and cannot be undone.`;
        
        if (!window.confirm(confirmMessage)) {
            return;
        }
        
        this.setState({ loading: true });
        
        try {
            const apiEndpoint = `/invoices/settle/${invoiceId}`;
            await API.put(apiEndpoint);
            
            alert('✅ Deposit invoice settled successfully!\n\nThe deposit status will be updated automatically.');
            window.location.reload();
        } catch (error) {
            console.error('Error settling deposit:', error);
            alert('⌐ Error settling deposit invoice. Please try again.');
        } finally {
            this.setState({ loading: false });
        }
    };

    getFilteredJobs = () => {
        const workingArray = this.state.transactions;
        let jobs = [];

        if (this.state.showVinFilter) {
            if (this.state.filteredByVin.length > 0) {
                jobs = this.state.filteredByVin;
            }
        } else if (this.state.showNameFilter) {
            if (this.state.filteredByName.length > 0) {
                jobs = this.state.filteredByName;
            }
        } else if (this.state.showSearchResults) {
            if (this.state.filteredTransactions.length > 0) {
                jobs = this.state.filteredTransactions;
            }
        } else {
            jobs = workingArray.filter(item => moment(item.invoice_date) >= this.state.startDate && moment(item.invoice_date) <= this.state.endDate);
        }

        // Apply dealer group filters
        if (this.props.userType === "dealer" && ScopeService.isDealerGroupUser()) {
            if (!isAllDealerships(this.state.selectedDealerId)) {
                jobs = jobs.filter(item => String(item.dealer_id) === String(this.state.selectedDealerId));
            }
            if (this.state.selectedInstallerId !== "all") {
                jobs = jobs.filter(item =>
                    (item.installer_name || item.specialist_name || item.Name) === this.state.selectedInstallerId
                );
            }
        }
        // Installer-side: filter by dealer group and/or specific dealership
        if (this.props.userType === "installer" && this.state.selectedDealerGroupId !== "all") {
            jobs = jobs.filter(item =>
                String(item.dealer_group_id) === String(this.state.selectedDealerGroupId)
            );
            if (this.state.selectedDealerGroupDealerId !== "all") {
                jobs = jobs.filter(item =>
                    String(item.dealer_id) === String(this.state.selectedDealerGroupDealerId)
                );
            }
        }

        // Apply states filter
        if (this.state.selectedOption === "Voided") {
            // Voided rows are only ever shown when explicitly requested.
            jobs = jobs.filter(item => isVoidedLike(item.payment_state));
        } else {
            // Every other view (including "All States") excludes voided rows.
            jobs = jobs.filter(item => !isVoidedLike(item.payment_state));
            if (this.state.selectedOption !== "All States") {
                jobs = jobs.filter(item => {
                    // "Paid" filter must cover both Stripe-paid and offline-settled rows.
                    if (this.state.selectedOption === 'Paid') return isPaidLike(item.payment_state);
                    return _.capitalize(item.payment_state) === this.state.selectedOption;
                });
            }
        }
        // Apply types filter
        if (this.state.selectedType !== "All Types") {
            if (this.state.selectedType === "Retail") {
                jobs = jobs.filter(item => item.Request_type === "installer");
            } else {
                jobs = jobs.filter(item => item.Request_type === "dealer");
            }
        }

        return jobs;
    };

    handleDealerMonthlyStatement = () => {
        this.setState({ loading: true });

        try {
            const monthlyJobs = this.getFilteredJobs();

            const csvContent = this.convertToDealerCSV(monthlyJobs);
            
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                
                const from = moment(this.state.startDate).format('MMM-D-YYYY');
                const to = moment(this.state.endDate).format('MMM-D-YYYY');
                link.setAttribute('download', `statement-${from}-to-${to}.csv`);
                
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            this.setState({ loading: false });

        } catch (error) {
            console.error('Error generating dealer CSV:', error);
            alert('Error generating download. Please try again.');
            this.setState({ loading: false });
        }
    };

    handleBatchCheckMode = () => {
    this.setState({
        batchCheckMode: true,
        selectedInvoices: [],
        selectedOption: "Invoiced",
        // Only set type filter for installers (dealers don't have retail/dealer type distinction)
        ...(this.props.userType === "installer" ? { selectedType: "Dealer" } : {})
    });
};

handleExitBatchMode = () => {
    this.setState({ 
        batchCheckMode: false,
        selectedInvoices: []
    });
};

handleInvoiceSelect = (invoice, isSelected) => {
    const { selectedInvoices } = this.state;
    const MAX_INVOICES = 25;
    
    console.log('handleInvoiceSelect called:', {
        isSelected,
        invoiceNumber: invoice.invoiceNumber,
        currentlySelected: selectedInvoices.length,
        selectedInvoices: selectedInvoices.map(i => i.invoiceNumber)
    });
    
    if (isSelected) {
        if (selectedInvoices.length >= MAX_INVOICES) {
            alert(`Maximum ${MAX_INVOICES} invoices can be processed in one batch. Please process this check and start a new batch for additional invoices.`);
            return;
        }
        const newSelected = [...selectedInvoices, invoice];
        console.log('Adding invoice, new array:', newSelected.map(i => i.invoiceNumber));
        this.setState({ 
            selectedInvoices: newSelected
        });
    } else {
        const newSelected = selectedInvoices.filter(inv =>
            inv.invoiceId !== invoice.invoiceId
        );
        console.log('Removing invoice, new array:', newSelected.map(i => i.invoiceNumber));
        this.setState({ 
            selectedInvoices: newSelected
        });
    }
};
handleOpenBatchCheck = () => {
    if (this.state.selectedInvoices.length === 0) {
        alert('Please select at least one invoice');
        return;
    }
    this.setState({ showBatchCheck: true });
};

handleCloseBatchCheck = () => {
    this.setState({ showBatchCheck: false });
};

handleBatchCheckSubmit = async (selectedInvoices, checkNumber, checkDate) => {
    // Use invoiceId (invoice_id = unique Stripe invoice key), NOT invoiceNumber (stripe_invoice = customer-facing number)
    const invoiceIds = selectedInvoices.map(inv => inv.invoiceId);

    console.log('Submitting batch check payment:', {
        selectedInvoices: selectedInvoices,
        invoiceIds: invoiceIds,
        checkNumber: checkNumber,
        checkDate: checkDate
    });

    try {
        const apiEndpoint = `/invoices/batch-settle-check`;
        await API.post(apiEndpoint, {
            invoiceIds,
            checkNumber,
            checkDate
        });

        alert(`Check payment processed successfully for ${invoiceIds.length} invoices`);

        this.setState({
            showBatchCheck: false,
            batchCheckMode: false,
            selectedInvoices: []
        });

        window.location.reload();
    } catch (error) {
        console.error('Error processing batch check:', error);
        throw error;
    }
};

handleBatchLinkSubmit = async (selectedInvoices, poNumber, checkNumber, checkDate) => {
    const invoiceIds = selectedInvoices.map(inv => inv.invoiceId);

    try {
        await API.post('/invoices/batch-link', {
            invoiceIds,
            poNumber: poNumber || null,
            checkNumber: checkNumber || null,
            checkDate: checkDate || null
        });

        alert(`Successfully linked ${invoiceIds.length} invoice${invoiceIds.length !== 1 ? 's' : ''}`);

        this.setState({
            showBatchCheck: false,
            batchCheckMode: false,
            selectedInvoices: []
        });

        window.location.reload();
    } catch (error) {
        console.error('Error linking invoices:', error);
        alert('Error linking invoices. Please try again.');
        throw error;
    }
};

    convertToDealerCSV = (data) => {
        const dealerData = data.filter(job => !job.isDeposit);

        if (dealerData.length === 0) {
            return "No invoices found for this period";
        }

        const isDealerGroup = this.props.userType === "dealer" && ScopeService.isDealerGroupUser();

        const headers = isDealerGroup
            ? [
                'Dealership', 'Invoice Date', 'Specialist Name', 'Vehicle', 'Service',
                'Amount', 'Payment Status', 'Invoice Number', 'PO Number',
                'Payment Made', 'Notes'
              ]
            : [
                'Invoice Date', 'Specialist Name', 'Vehicle', 'Service',
                'Amount', 'Payment Status', 'Invoice Number', 'PO Number',
                'Payment Made', 'Notes'
              ];

        const csvRows = [
            headers.join(','),
            ...dealerData.map(job => {
                const row = [
                    job.invoice_date ? convertFromUTC(job.invoice_date).format('YYYY-MM-DD') : '',
                    `"${this.getSpecialistName(job)}"`,
                    `"${(job.Year || '') + ' ' + (job.Make || '') + ' ' + (job.Model || '')}"`.trim(),
                    `"${job.Service_Requested || ''}"`,
                    (job.Request_Total || 0).toFixed(2),
                    `"${formatPaymentStateLabel(job, job.payout_id)}"`,
                    `"${job.stripe_invoice || ''}"`,
                    `"${job.payment_order || job.po_number || ''}"`,
                    isPaidLike(job.payment_state) ? 'Yes' : '',
                    ''
                ];
                if (isDealerGroup) {
                    row.unshift(`"${job.dealer_name || ''}"`);
                }
                return row.join(',');
            })
        ];

        return csvRows.join('\n');
    };

    getSpecialistName = (job) => {
        return job.installer_name || job.specialist_name || job.Name || 'Unknown Specialist';
    };

    handleDownloadCSV = () => {
        const csvData = this.getCurrentDisplayData();
        const csvContent = this.convertToCSV(csvData);
        
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            
            const today = moment().format('YYYY-MM-DD');
            const filterType = this.state.showVinFilter ? 'vin-filter' :
                              this.state.showNameFilter ? 'name-filter' :
                              this.state.showSearchResults ? 'search-results' :
                              this.state.range;
            link.setAttribute('download', `financials-${filterType}-${today}.csv`);
            
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    getCurrentDisplayData = () => {
        let jobs = [];

        if (this.state.showVinFilter) {
            if (this.state.filteredByVin.length > 0) {
                jobs = this.state.filteredByVin;
            }
        } else if (this.state.showNameFilter) {
            if (this.state.filteredByName.length > 0) {
                jobs = this.state.filteredByName;
            }
        } else if (this.state.showSearchResults) {
            if (this.state.filteredTransactions.length > 0) {
                jobs = this.state.filteredTransactions;
            }
        } else {
            jobs = this.state.transactions.filter(item =>
                moment(item.invoice_date) >= this.state.startDate &&
                moment(item.invoice_date) <= this.state.endDate
            );
        }

        // Apply dealer group filters
        if (this.props.userType === "dealer" && ScopeService.isDealerGroupUser()) {
            if (!isAllDealerships(this.state.selectedDealerId)) {
                jobs = jobs.filter(item => String(item.dealer_id) === String(this.state.selectedDealerId));
            }
            if (this.state.selectedInstallerId !== "all") {
                jobs = jobs.filter(item =>
                    (item.installer_name || item.specialist_name || item.Name) === this.state.selectedInstallerId
                );
            }
        }
        // Installer-side: filter by dealer group and/or specific dealership
        if (this.props.userType === "installer" && this.state.selectedDealerGroupId !== "all") {
            jobs = jobs.filter(item =>
                String(item.dealer_group_id) === String(this.state.selectedDealerGroupId)
            );
            if (this.state.selectedDealerGroupDealerId !== "all") {
                jobs = jobs.filter(item =>
                    String(item.dealer_id) === String(this.state.selectedDealerGroupDealerId)
                );
            }
        }

        // Apply states filter to ALL results (including search results)
        if (this.state.selectedOption === "Voided") {
            // Voided rows are only ever shown (and exported) when explicitly requested.
            jobs = jobs.filter(item => isVoidedLike(item.payment_state));
        } else {
            // Every other view (including "All States") excludes voided rows.
            jobs = jobs.filter(item => !isVoidedLike(item.payment_state));
            if (this.state.selectedOption !== "All States"){
                jobs = jobs.filter(item => {
                    // "Paid" filter must cover both Stripe-paid and offline-settled rows.
                    if (this.state.selectedOption === 'Paid') return isPaidLike(item.payment_state);
                    return _.capitalize(item.payment_state) === this.state.selectedOption;
                });
            }
        }
        // Apply types filter to ALL results (including search results)
        if (this.state.selectedType !== "All Types"){
            if(this.state.selectedType === "Retail"){
                jobs = jobs.filter(item => item.Request_type === "installer");
            } else {
                jobs = jobs.filter(item => item.Request_type === "dealer");
            }
        }

        return jobs.map(job => {
            let serviceForCSV = job.Service_Requested || "";
            if (this.props.userType === "installer" && 
                job.payment_type === 'deposit') {
                serviceForCSV = `Deposit for ${job.Service_Requested || 'Unknown Service'}`;
            }
            
            const year = job.Year || "";
            const make = job.Make || "";
            const model = job.Model || "";
            const vehicle = `${year} ${make} ${model}`.trim();
            
            const invoiceAmount = job.invoice_amount || 0;
            const platformFee = job.platform_fee || 0;
            
            // Include paid date in CSV data
            // Format paid date if available — covers both Stripe-paid and offline-settled rows.
            const paidDate = isPaidLike(job.payment_state) && job.payment_date
                ? convertFromUTC(job.payment_date).format("YYYY-MM-DD")
                : "";

            const payoutId = job.payout_id || "";
            const checkNumber = (payoutId && !payoutId.startsWith("po_")) ? payoutId : "";

            return {
                invoiceDate: job.invoice_date ? convertFromUTC(job.invoice_date).format("YYYY-MM-DD") : "",
                paidDate: paidDate,
                vehicle: vehicle,
                vin: job.VIN || job.vin || "",
                currentState: formatPaymentStateLabel(job, payoutId),
                service: serviceForCSV,
                name: job.Name || "",
                amount: invoiceAmount.toFixed(2),
                invoiceNumber: (typeof job.stripe_invoice === 'string' ? job.stripe_invoice : job.stripe_invoice?.id) || job.invoice_id || "",
                requestType: (job.Request_type === "dealer" || job.Request_type === "Dealer") ? "Dealer" : "Retail",
                poNumber: job.payment_order || job.po_number || "",
                checkNumber: checkNumber,
                fee: platformFee.toFixed(2),
                earned: (invoiceAmount - platformFee).toFixed(2),
                cardLast4: job.card_last4 || "",
                cardType: job.card_type || "",
                isDeposit: job.payment_type === 'deposit'
            };
        });
    };

    convertToCSV = (data) => {
        if (data.length === 0) {
            return "No data available for export";
        }

const headers = [
    'Invoice Date',
    'Paid Date',
    'Vehicle',
    'VIN',
    'State',
    'Service',
    'Customer Name',
    'Amount',
    'Invoice Number',
    'Request Type',
    'PO Number',
    'Check Number',
    'Fee',
    'Earned',
    'Card Last 4',
    'Card Type'
];
        const csvRows = [
            headers.join(','),
...data.map(row => [
    row.invoiceDate,
    row.paidDate,
    `"${row.vehicle}"`,
    `"${row.vin}"`,
    row.currentState,
    `"${row.service}"`,
    `"${row.name}"`,
    row.amount,
    `"${row.invoiceNumber}"`,
    row.requestType,
    `"${row.poNumber}"`,
    `"${row.checkNumber}"`,
    row.fee,
    row.earned,
    row.cardLast4,
    row.cardType
].join(','))        ];

        return csvRows.join('\n');
    };

    renderInvoiceSearch = () => {
        const invoiceNumbers = [...new Set(
            this.state.transactions
                .filter(t => t.stripe_invoice || t.invoice_id)
                .map(t => t.stripe_invoice || t.invoice_id)
        )].sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
        
        return (
            <div className="search-group">
                <label htmlFor="invoiceSearch">Search Invoice #:</label>
                <div className="search-input-group">
                    <input
                        type="text"
                        className="search-input"
                        id="invoiceSearch"
                        list="invoiceOptions"
                        placeholder="Type to search invoices..."
                        value={this.state.searchTerm}
                        onChange={this.handleSearchChange}
                        onKeyDown={(e) => {
                            if (e.key === 'Escape') {
                                this.clearSearch();
                            }
                        }}
                    />
                    {this.state.searchTerm && (
                        <button 
                            className="clear-search-btn"
                            onClick={this.clearSearch}
                            type="button"
                        >
                            ×
                        </button>
                    )}
                </div>
                <datalist id="invoiceOptions">
                    {invoiceNumbers.map((invoice, idx) => (
                        <option key={idx} value={invoice} />
                    ))}
                </datalist>
            </div>
        );
    };

    renderNameSearch = () => {
        const names = [...new Set(
            this.state.transactions
                .filter(t => t.Name)
                .map(t => t.Name)
        )].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

        return (
            <div className="search-group">
                <label htmlFor="nameSearch">Search by Name:</label>
                <div className="search-input-group">
                    <input
                        type="text"
                        className="search-input"
                        id="nameSearch"
                        list="nameOptions"
                        placeholder="Type to search names..."
                        value={this.state.nameSearchTerm}
                        onChange={this.handleNameSearchChange}
                        onKeyDown={(e) => {
                            if (e.key === 'Escape') {
                                this.clearNameFilter();
                            }
                        }}
                    />
                    {this.state.nameSearchTerm && (
                        <button
                            className="clear-search-btn"
                            onClick={this.clearNameFilter}
                            type="button"
                        >
                            ×
                        </button>
                    )}
                </div>
                <datalist id="nameOptions">
                    {names.map((name, idx) => (
                        <option key={idx} value={name} />
                    ))}
                </datalist>
            </div>
        );
    };

    renderVinSearch = () => {
        const vins = [...new Set(
            this.state.transactions
                .filter(t => t.VIN || t.vin)
                .map(t => t.VIN || t.vin)
        )].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

        return (
            <div className="search-group">
                <label htmlFor="vinSearch">Search by VIN:</label>
                <div className="search-input-group">
                    <input
                        type="text"
                        className="search-input"
                        id="vinSearch"
                        list="vinOptions"
                        placeholder="Type to search VIN..."
                        value={this.state.vinSearchTerm}
                        onChange={this.handleVinSearchChange}
                        onKeyDown={(e) => {
                            if (e.key === 'Escape') {
                                this.clearVinFilter();
                            }
                        }}
                    />
                    {this.state.vinSearchTerm && (
                        <button
                            className="clear-search-btn"
                            onClick={this.clearVinFilter}
                            type="button"
                        >
                            ×
                        </button>
                    )}
                </div>
                <datalist id="vinOptions">
                    {vins.map((vin, idx) => (
                        <option key={idx} value={vin} />
                    ))}
                </datalist>
            </div>
        );
    };

    displayDetails = async (requestId, invoiceId) => {
        let dispRequest = `/requestimates/fullrequest/?Id=${requestId}`;        
        const  { data : selectedRequests }  = await API.get(dispRequest);
        let servicesRequest = `/requestservice/${requestId}`;        
        const  { data : services }  = await API.get(servicesRequest);
        let notesRequest = `/requestnotes/${requestId}`;        
        const  { data : notes }  = await API.get(notesRequest);
        selectedRequests[0].invoiceId = invoiceId;
        this.setState({ selectedRequestimate : selectedRequests[0], services, notes, showDetails : true});
    }

    displayPO = async (invoiceId, requestId) => {
        let poNumberRecord = this.state.transactions.filter(trans => trans.request_id === requestId);
        this.setState({invoiceId, requestId, poNumber: poNumberRecord[0].payment_order, showPO : true});
    }

    updateInvoiceMetadata = async (invoiceId, PO) => {
        const apiEndpoint = `/invoices/meta/${invoiceId}`;
        await API.put(apiEndpoint, { invoiceId, PO });
    };

    handleAddPO = async (PO) => {
        if (this.state.invoiceId) {
            await this.updateInvoiceMetadata(this.state.invoiceId, PO);
        }
        // Also store PO on the request record for pre-invoice scenarios
        if (this.state.requestId) {
            try {
                await API.put(`/requestimates/po/${this.state.requestId}`, { poNumber: PO });
            } catch (err) {
                console.error('Failed to save PO on request:', err);
            }
        }
        this.setState({ showPO : false })
        window.location = '/financials';
    }

    handleInvoice = async () => {
        const apiEndpoint =  "/invoices/settle/"+this.state.invoiceId;
        await API.put(apiEndpoint);
        this.setState({ showPO : false })
        window.location = '/financials';
    }
            
    handleOpen = async () => {
        window.open("https://s3.us-east-1.amazonaws.com/jobvious.app/W-9+Jobvious.pdf", "_blank");
    }

    closePO = async () => {
        this.setState( {showPO : false})
    }

    addCustomClose = () => {
        this.setState( {showDetails : false});
    };

    handleDisplayRange = (event) => {
        const {value} = event.currentTarget;
        var newDay = moment(this.state.selectedDate);
        var displayString = "";

        if (this.state.range === "day") {
            if (value === "today"){
                newDay = moment();    
            }
            if (value === "less"){
                newDay = moment(newDay).subtract(1, "day");
            }
            if (value === "more"){
                newDay = moment(newDay).add(1, "day");
            }
            var endDate = moment(newDay).endOf('day');
        }
        if (this.state.range === "week") {
            if (value === "today"){
                newDay = moment().startOf("week");    
            }
            if (value === "less"){
                newDay = moment(newDay).subtract(1, "week");
            }
            if (value === "more"){
                newDay = moment(newDay).add(1, "week");
            }
            endDate = moment(newDay).endOf("week");
        }

        if (this.state.range === "month") {
            if (value === "today"){
                newDay = moment().startOf("month");
            }
            if (value === "less"){
                newDay = moment(newDay).subtract(1, "month");
            }
            if (value === "more"){
                newDay = moment(newDay).add(1, "month");
            } 
            endDate = moment(newDay).endOf("month");
        }

        displayString = this.getDisplayString(newDay, this.state.range);
        this.setState( {selectedDate : newDay, startDate:newDay , endDate, displayString});
    };

    handleRange = (event) => {
        const {value} = event.currentTarget;
        var displayString = "";
        var newDay = moment(this.state.selectedDate);
        var endDate = "";

        if (value === "custom") {
            // Default the custom date inputs to current startDate and endDate
            const defaultStart = this.state.startDate ? this.state.startDate.format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD');
            const defaultEnd = this.state.endDate ? this.state.endDate.format('YYYY-MM-DD') : moment().endOf('month').format('YYYY-MM-DD');
            
            this.setState({ 
                range: "custom",
                showCustomInputs: true,
                customStartDate: defaultStart,
                customEndDate: defaultEnd
            });
            return;
        } else {
            this.setState({ showCustomInputs: false });
        }

        if (value === "week") {
            newDay = moment(newDay).startOf('week');
            endDate = moment(newDay).endOf('week');
        }
        if (value === "month") {
            newDay = moment(newDay).startOf('month');
            endDate = moment(newDay).endOf('month');
        }
        if (value === "day") {
            endDate = moment(newDay).endOf('day');
        }

        displayString = this.getDisplayString(newDay, value);
        this.setState({ range : value , selectedDate : newDay, startDate:newDay, endDate, displayString});
    };

    // Custom date range handlers
    handleCustomDateRange = () => {
        const { customStartDate, customEndDate } = this.state;
        
        if (!customStartDate || !customEndDate) {
            alert("Please select both start and end dates");
            return;
        }
        
        const startDate = moment(customStartDate).startOf('day');
        const endDate = moment(customEndDate).endOf('day');
        
        if (endDate.isBefore(startDate)) {
            alert("End date must be after start date");
            return;
        }
        
        if (endDate.diff(startDate, 'years') > 2) {
            if (!window.confirm("This is a large date range and may take time to load. Continue?")) {
                return;
            }
        }
        
        const displayString = this.getDisplayString(startDate, "custom");
        this.setState({ 
            range: "custom",
            selectedDate: startDate, 
            startDate: startDate, 
            endDate: endDate, 
            displayString 
        });
    };

    handleCustomStartDateChange = (event) => {
        this.setState({ customStartDate: event.target.value });
    };

    handleCustomEndDateChange = (event) => {
        this.setState({ customEndDate: event.target.value });
    };

    formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    };

    getFinancialMetrics = (jobs) => {
        const totalAmount = jobs.reduce((sum, job) => {
            const amount = job.invoice_amount || 0;
            return sum + amount;
        }, 0);
        
        const totalPaid = jobs
            .filter(job => isPaidLike(job.payment_state))
            .reduce((sum, job) => {
                const amount = job.invoice_amount || 0;
                return sum + amount;
            }, 0);
        
        const totalPending = jobs
            .filter(job => job.payment_state === 'invoiced' || job.payment_state === 'pending')
            .reduce((sum, job) => {
                const amount = job.invoice_amount || 0;
                return sum + amount;
            }, 0);
        
        const totalEarned = jobs.reduce((sum, job) => {
            const invoiceAmount = job.invoice_amount || 0;
            const platformFee = job.platform_fee || 0;
            return sum + (invoiceAmount - platformFee);
        }, 0);

        return { totalAmount, totalPaid, totalPending, totalEarned };
    };

    render() { 
        const { isDesktop, error, loading } = this.state;

        if (error) {
            return (
                <div className="financials-container">
                    <div className="error-message">
                        <h3>Error Loading Financial Data</h3>
                        <p>{error}</p>
                        <button onClick={() => window.location.reload()}>Refresh Page</button>
                    </div>
                </div>
            );
        }
        
        let jobs = this.getFilteredJobs();

        let dealerView = false;
        if (this.props.userType === "dealer")
            dealerView = true;

        const { totalAmount, totalPaid, totalPending, totalEarned } = this.getFinancialMetrics(jobs);

        // monthlyCount reflects the fully filtered table data
        const monthlyCount = jobs.length;

// Update the columns array in the render() method around line 850
const columns = [];
if (this.state.batchCheckMode) {
    columns.push({
        dataField: 'select',
        text: '',
        formatter: (cell, row) => {
            const isSelected = this.state.selectedInvoices.some(inv =>
                inv.invoiceId === row.invoiceId
            );
            console.log('Rendering checkbox for:', row.invoiceNumber, 'isSelected:', isSelected);
            return (
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={(e) => {
                        console.log('Checkbox clicked:', row.invoiceId, row.invoiceNumber, e.target.checked);
                        this.handleInvoiceSelect(row, e.target.checked);
                    }}
                />
            );
        },
        headerStyle: { width: '50px' }
    });
}
// Dealership column for dealer-group users (full group access)
if (this.props.userType === "dealer" && ScopeService.isDealerGroupUser()) {
    columns.push({
        dataField: 'dealer_name',
        text: "Dealership",
        sort: true
    });
}
// Location column — only when viewing all locations with multi-location installer
const effectiveLocId = this.state.financialsLocationId || this.props.selectedLocationId;
if (isMultiLocation(this.props.locations) && isAllLocations(effectiveLocId) && this.props.userType === "installer") {
    columns.push({
        dataField: 'locationName',
        text: "Location",
        formatter: (cell, row) => {
            if (!row.location_id) return '-';
            const locName = row.locationName || getLocationName((this.props.locations || []).find(l => String(l.location_id) === String(row.location_id)));
            return (
                <span className="jv-location-badge" style={{
                    backgroundColor: getLocationBadgeColor(row.location_id, this.props.locations),
                    fontSize: '0.65rem'
                }}>
                    {locName}
                </span>
            );
        },
        headerStyle: { width: '120px' }
    });
}
if (dealerView) {
    // Dealer column order: Invoiced → Invoice # → Name → Vehicle → Work → Amount → PO # → Paid Date
    columns.push({
        dataField: 'invoiceDate',
        text: "Invoiced",
        sort: true,
        formatter: (cell) => cell ? moment(cell).format("MMM D, YYYY") : ""
    }, {
        dataField: 'invoiceNumber',
        text: "Invoice #",
        sort: true,
        formatter: (cell, row) => {
            if (cell && row.link) {
                return <a href={row.link} target="_blank" rel="noopener noreferrer" title="Pay this invoice">{cell}</a>;
            }
            return cell || <span className="text-muted">Pending</span>;
        }
    }, {
        dataField: 'name',
        text: "Name"
    }, {
        dataField: 'vehicle',
        text: "Vehicle",
        formatter: (cell, row) => (<a href={row.link} onClick={(e) => {e.preventDefault(); this.displayDetails(row.requestId, row.invoiceNumber)}}> {cell} </a>)
    }, {
        dataField: 'service',
        text: "Work",
        formatter: (cell, row) => {
            if (row.isDeposit) {
                return (
                    <span style={{
                        color: 'var(--color-warning-dark)',
                        fontWeight: '500',
                        fontSize: '0.95em'
                    }}>
                        {cell}
                    </span>
                );
            }
            return cell;
        }
    }, {
        dataField: 'amount',
        text: "Amount",
        formatter: (cell, row) => this.formatCurrency(parseFloat(cell))
    }, {
        dataField: 'poNumber',
        text: "PO #",
        formatter: (cell, row) => (
            <button type="button" onClick={() => this.displayPO(row.invoiceId, row.requestId)}
               title={cell ? "Click to edit PO#" : "Click to enter PO#"}
               style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0, color: 'var(--color-brand-teal)', textDecoration: 'underline' }}
            >
                {cell || <i className="fa-sharp fa-regular fa-plus-circle text-muted" />}
            </button>
        )
    }, {
        dataField: 'paidDate',
        text: "Paid Date",
        sort: true,
        formatter: (cell, row) => {
            if (cell) return moment(cell).format("MMM D, YYYY");
            if (row.invoiceId && row.currentState === 'Invoiced') {
                return (
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => this.handleResendInvoice(row.invoiceId)}
                    >
                        Resend
                    </button>
                );
            }
            return "";
        }
    });
} else {
    // Installer column order: Invoiced → Number → Name → Vehicle → Work → Amount → State → Paid Date
    columns.push({
        dataField: 'invoiceDate',
        text: "Invoiced",
        sort: true,
        formatter: (cell) => cell ? moment(cell).format("MMM D, YYYY") : ""
    }, {
        dataField: 'invoiceNumber',
        text: "Number",
        formatter: (cell, row) => (
            <button
                type="button"
                onClick={() => this.handleOpenInvoice(row.invoiceId)}
                style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0, color: 'var(--color-brand-teal)', textDecoration: 'underline' }}
            >
                {cell}
            </button>
        )
    }, {
        dataField: 'name',
        text: "Name"
    }, {
        dataField: 'vehicle',
        text: "Vehicle",
        formatter: (cell, row) => (<a href={row.link} onClick={(e) => {e.preventDefault(); this.displayDetails(row.requestId, row.invoiceNumber)}}> {cell} </a>)
    }, {
        dataField: 'service',
        text: "Work",
        formatter: (cell, row) => {
            if (row.isDeposit) {
                return (
                    <span style={{
                        color: 'var(--color-warning-dark)',
                        fontWeight: '500',
                        fontSize: '0.95em'
                    }}>
                        {cell}
                    </span>
                );
            }
            return cell;
        }
    }, {
        dataField: 'amount',
        text: "Amount",
        formatter: (cell, row) => this.formatCurrency(parseFloat(cell))
    }, {
        dataField: 'currentState',
        text: "State",
        formatter: (cell, row) => {
            // Disable state links in batch mode
            if (this.state.batchCheckMode) {
                if (row.isSplitPayment) {
                    return <span>{cell} <span className="split-badge">SPLIT</span></span>;
                }
                return cell;
            }

            // Handle split payments - show expandable indicator
            if (row.isSplitPayment) {
                const isExpanded = this.state.expandedRows.includes(row.invoiceId);
                return (
                    <span
                        className="split-payment-state"
                        onClick={(e) => { e.stopPropagation(); this.handleToggleSplitExpand(row.invoiceId); }}
                        style={{ cursor: 'pointer' }}
                    >
                        {cell}
                        <span className="split-badge">SPLIT</span>
                        <span className="expand-icon"><i className={`fa-sharp fa-regular ${isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i></span>
                    </span>
                );
            }

            if (cell === "Invoiced" && row.requestType === "Dealer"){
                return <a href={row.link} onClick={(e) => {e.preventDefault(); this.displayPO(row.invoiceId, row.requestId, row.poNumber)}}>{cell} </a>;
            } else if (cell === "Invoiced" && row.isDeposit) {
                return <a href={row.link} onClick={(e) => {e.preventDefault(); this.handleSettleDeposit(row.invoiceId, row.amount, row.invoiceNumber)}}>{cell} </a>;
            } else {
                return cell;
            }
        }
    }, {
        dataField: 'paidDate',
        text: "Paid Date",
        sort: true,
        formatter: (cell, row) => {
            if (cell) return moment(cell).format("MMM D, YYYY");
            if (row.invoiceId && row.currentState === 'Invoiced') {
                return (
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => this.handleResendInvoice(row.invoiceId)}
                    >
                        Resend
                    </button>
                );
            }
            return "";
        }
    });
}

// QBO sync status column (installer only, when QBO Online connected)
if (this.state.qboConnected && this.props.company?.qb_mode === 'online' && !dealerView && isInstallerAdmin(this.props.user)) {
    columns.push({
        dataField: 'qbo_invoice_id',
        text: 'QBO',
        headerStyle: { width: '50px', textAlign: 'center' },
        formatter: (cell, row) => {
            if (cell) {
                // Synced
                return (
                    <i className="fa-sharp fa-solid fa-check-circle" style={{ color: 'var(--color-success-dark)', fontSize: '1rem' }} title="Synced to QuickBooks"></i>
                );
            }
            if (row.qbo_sync_error) {
                // Error — click to retry
                return (
                    <i
                        className="fa-sharp fa-solid fa-exclamation-circle"
                        style={{ color: 'var(--color-danger)', fontSize: '1rem', cursor: 'pointer' }}
                        title="Sync failed — click to retry"
                        onClick={(e) => { e.stopPropagation(); this.handleQboRetrySingle(row.invoiceId); }}
                    ></i>
                );
            }
            if (row.currentState === 'Paid') {
                // Pending sync
                return (
                    <i className="fa-sharp fa-regular fa-clock" style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem' }} title="Pending sync"></i>
                );
            }
            // Not paid yet — no indicator
            return <span style={{ color: 'var(--color-gray-300)' }}>—</span>;
        },
        style: { textAlign: 'center' }
    });
}

// Actions column (installer only) — revise unpaid dealer invoices
if (!dealerView) {
    columns.push({
        dataField: 'actions',
        text: '',
        isDummyField: true,
        headerStyle: { width: '40px' },
        formatter: (cell, row) => {
            // Only show for unpaid dealer invoices
            if (row.requestType !== 'Dealer' || row.currentState !== 'Invoiced') {
                return null;
            }
            return (
                <button
                    type="button"
                    onClick={(e) => { e.stopPropagation(); this.handleReviseInvoice(row); }}
                    style={{ cursor: 'pointer', background: 'none', border: 'none', padding: 0, color: 'var(--color-brand-teal)' }}
                    title="Void invoice — replace or void only"
                >
                    <i className="fa-sharp fa-regular fa-pen-to-square"></i>
                </button>
            );
        },
        style: { textAlign: 'center' }
    });
}

        var displayArray = [];
        
        for (let i = 0; i < jobs.length; i++) {
            let displayObject = {
                invoiceDate: "",
                paidDate: "",
                currentState: "",
                link: "",
                requestId: "",
                requestType: "",
                service: "",
                vehicle: "",
                amount: "",
                fee: "",
                invoiceNumber: "",
                invoiceId: "",
                poNumber: "",
                name: "",
                dealer_name: "",
                isDeposit: false,
                isSplitPayment: false,
                splitPayments: []
            };

            const job = jobs[i];

            displayObject.invoiceDate = job.invoice_date ? convertFromUTC(job.invoice_date).format("YYYY-MM-DD") : "";
    // payment_date = when the customer paid (check date for checks, charge date for cards).
    // payout_date = when funds hit the bank (Stripe only). Fall back to payout_date if
    // payment_date is missing, and to the most recent split for split-payment rows.
    let effectivePaymentDate = job.payment_date || job.payout_date || null;
    let effectivePayoutId = job.payout_id || null;
    if ((!effectivePaymentDate || !effectivePayoutId) && Array.isArray(job.split_payments) && job.split_payments.length > 0) {
        const paidSplits = job.split_payments.filter(s => isPaidLike(s.payment_state) && (s.payment_date || s.payout_date));
        if (paidSplits.length > 0) {
            const splitDate = (s) => s.payment_date || s.payout_date;
            const latest = paidSplits.reduce((a, b) =>
                new Date(splitDate(a)) > new Date(splitDate(b)) ? a : b
            );
            if (!effectivePaymentDate) effectivePaymentDate = splitDate(latest);
            if (!effectivePayoutId) effectivePayoutId = latest.payout_id || null;
        }
    }
    displayObject.paidDate = isPaidLike(job.payment_state) && effectivePaymentDate
        ? convertFromUTC(effectivePaymentDate).format("YYYY-MM-DD")
        : "";
            displayObject.requestId = job.request_id || "";
            displayObject.requestType = "Retail";
            
            if (job.Request_type === "dealer" || job.Request_type === "Dealer") {
                displayObject.requestType = "Dealer";
            }
            
            if (this.props.userType === "installer" && job.payment_type === 'deposit') {
                displayObject.service = `💰 Deposit for ${job.Service_Requested || 'Unknown Service'}`;
                displayObject.isDeposit = true;
            } else if (job.payment_type === 'product_sale') {
                displayObject.service = `🛒 ${job.sale_number || 'Product Sale'}`;
                displayObject.isDeposit = false;
                displayObject.requestType = "Product";
            } else {
                displayObject.service = job.Service_Requested || "";
                displayObject.isDeposit = false;
            }
            
            displayObject.currentState = formatPaymentStateLabel(job, effectivePayoutId);
            displayObject.link = job.hosted_invoice_url || "";
            
            const year = job.Year || "";
            const make = job.Make || "";
            const model = job.Model || "";
            displayObject.vehicle = job.payment_type === 'product_sale' ? "—" : `${year} ${make} ${model}`.trim();
            
            displayObject.amount = (job.invoice_amount !== null && job.invoice_amount !== undefined) 
                ? job.invoice_amount.toFixed(2) 
                : "0.00";
            
            displayObject.fee = (job.platform_fee !== null && job.platform_fee !== undefined) 
                ? job.platform_fee.toFixed(2) 
                : "0.00";
            
            displayObject.invoiceNumber = (typeof job.stripe_invoice === 'string' ? job.stripe_invoice : job.stripe_invoice?.id) || job.invoice_id || "";
            displayObject.poNumber = job.payment_order || job.po_number || "";
            displayObject.invoiceId = job.invoice_id || "";
            displayObject.name = job.Name || "";
            displayObject.dealer_name = job.dealer_name || "";
            displayObject.location_id = job.location_id || job.locationId || null;
            displayObject.locationName = job.locationName || job.location_name || "";

            const invoiceAmount = job.invoice_amount || 0;
            const platformFee = job.platform_fee || 0;
            displayObject.earned = (invoiceAmount - platformFee).toFixed(2);

            // Split payment data from API. NOTE: the server's `is_split_payment`
            // flag is FALSE for splits (the parent row is payment_type 'final',
            // not 'final_parent'), so detect a split by the presence of nested
            // split_payments[] — never by that flag.
            displayObject.splitPayments = job.split_payments || [];
            displayObject.isSplitPayment = displayObject.splitPayments.length > 0 || !!job.is_split_payment;

            // QBO sync status
            displayObject.qbo_invoice_id = job.qbo_invoice_id || null;
            displayObject.qbo_sync_error = job.qbo_sync_error || false;

            displayArray.push(displayObject);
        }

        // Latest invoice first. invoiceDate is YYYY-MM-DD so string compare works.
        // Previous comparator returned a boolean, which JS coerces to 0/1 — that
        // can't represent "a before b" and made the sort unstable.
        displayArray.sort((a, b) => {
            const dateA = a.invoiceDate || "";
            const dateB = b.invoiceDate || "";
            if (dateA !== dateB) {
                return dateB.localeCompare(dateA);
            }
            const stateA = a.currentState || "";
            const stateB = b.currentState || "";
            return stateA.localeCompare(stateB);
        });

        const requests = displayArray;

        // Use CSS classes for row styling based on request type
        const rowClasses = (row, rowIndex) => {
            // Dealer/Wholesale gets orange border, Retail/Installer gets blue border
            const type = (row.requestType || '').toLowerCase();
            return type === "dealer" ? "source-dealer" : "source-retail";
        };

        // Expandable row configuration for split payments
        const expandRow = {
            renderer: (row) => {
                if (!row.isSplitPayment || !row.splitPayments || row.splitPayments.length === 0) {
                    return null;
                }

                return (
                    <div className="split-payment-details">
                        <div className="split-payment-header">
                            <strong>Payment Breakdown</strong>
                        </div>
                        <table className="jv-table jv-table-sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Method</th>
                                    <th>Amount</th>
                                    <th>Status</th>
                                    <th>Date</th>
                                    <th>Reference</th>
                                </tr>
                            </thead>
                            <tbody>
                                {row.splitPayments.map((split, index) => {
                                    let reference = '-';
                                    if (split.card_last4) {
                                        reference = `${split.card_type || 'Card'} •${split.card_last4}`;
                                    } else if (split.payout_id && !split.payout_id.startsWith('po_')) {
                                        reference = `Check #${split.payout_id}`;
                                    }

                                    return (
                                        <tr key={index} className="split-row">
                                            <td>{split.payment_sequence || index + 1}</td>
                                            <td>
                                                <span className={`method-badge method-${(split.payment_method || 'unknown').toLowerCase()}`}>
                                                    {split.payment_method || 'Unknown'}
                                                </span>
                                            </td>
                                            <td>{this.formatCurrency(split.customer_total_paid || 0)}</td>
                                            <td>
                                                <span className={`status-badge status-${(split.payment_state || 'pending').toLowerCase()}`}>
                                                    {_.capitalize(split.payment_state || 'pending')}
                                                </span>
                                            </td>
                                            <td>{split.payment_date ? convertFromUTC(split.payment_date).format('MMM D, YYYY') : '-'}</td>
                                            <td>{reference}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                );
            },
            expanded: this.state.expandedRows,
            onExpand: (row, isExpand) => {
                if (isExpand) {
                    this.setState({ expandedRows: [...this.state.expandedRows, row.invoiceId] });
                } else {
                    this.setState({ expandedRows: this.state.expandedRows.filter(id => id !== row.invoiceId) });
                }
            },
            onlyOneExpanding: false,
            expandByColumnOnly: true,
            showExpandColumn: false,
            expandableRow: (row) => row.isSplitPayment && row.splitPayments && row.splitPayments.length > 0
        };
          
        return ( 
            <React.Fragment>
                <div className={`financials-container ${isDesktop ? 'desktop' : 'mobile'}`}>
                    {/* Header */}
                    <div className="financials-header">
                        <div className="header-content">
                            <div className="header-nav">
                                {isDesktop && (
                                    <div className="view-toggle">
                                        <button
                                            className={this.state.range === "day" ? "active" : ""}
                                            onClick={this.handleRange}
                                            value="day"
                                            disabled={this.state.showSearchResults || this.state.showNameFilter || this.state.showVinFilter}
                                        >
                                            Day
                                        </button>
                                        <button
                                            className={this.state.range === "week" ? "active" : ""}
                                            onClick={this.handleRange}
                                            value="week"
                                            disabled={this.state.showSearchResults || this.state.showNameFilter || this.state.showVinFilter}
                                        >
                                            Week
                                        </button>
                                        <button
                                            className={this.state.range === "month" ? "active" : ""}
                                            onClick={this.handleRange}
                                            value="month"
                                            disabled={this.state.showSearchResults || this.state.showNameFilter || this.state.showVinFilter}
                                        >
                                            Month
                                        </button>
                                        <button
                                            className={this.state.range === "custom" ? "active" : ""}
                                            onClick={this.handleRange}
                                            value="custom"
                                            disabled={this.state.showSearchResults || this.state.showNameFilter || this.state.showVinFilter}
                                        >
                                            Custom
                                        </button>
                                    </div>
                                )}
                                
                                {/* Date Display Area - shows date range or custom inputs, with invoice count below */}
                                <div className="date-display-area">
                                    {this.state.showCustomInputs ? (
                                        <div className="custom-date-inputs-inline">
                                            <div className="date-input-group">
                                                <label htmlFor="customStartDate">From:</label>
                                                <input
                                                    type="date"
                                                    id="customStartDate"
                                                    value={this.state.customStartDate}
                                                    onChange={this.handleCustomStartDateChange}
                                                    max={this.state.customEndDate || undefined}
                                                />
                                            </div>
                                            <div className="date-input-group">
                                                <label htmlFor="customEndDate">To:</label>
                                                <input
                                                    type="date"
                                                    id="customEndDate"
                                                    value={this.state.customEndDate}
                                                    onChange={this.handleCustomEndDateChange}
                                                    min={this.state.customStartDate || undefined}
                                                />
                                            </div>
                                            <button 
                                                className="apply-custom-date-btn"
                                                onClick={this.handleCustomDateRange}
                                                disabled={!this.state.customStartDate || !this.state.customEndDate}
                                            >
                                                Apply
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="date-display">
                                            {this.state.showVinFilter ? (
                                                `VIN Filter Results`
                                            ) : this.state.showNameFilter ? (
                                                `Name Filter Results`
                                            ) : this.state.showSearchResults ? (
                                                `Search Results`
                                            ) : (
                                                this.getDisplayString(moment(this.state.selectedDate || this.state.today), this.state.range)
                                            )}
                                        </div>
                                    )}
                                    <div className="invoice-count-below">
                                        ({displayArray.length} invoice{displayArray.length !== 1 ? 's' : ''})
                                    </div>
                                </div>
                                
                                <ButtonGroup className="nav-controls">
                                    <Button
                                        variant="outline-secondary"
                                        onClick={this.handleDisplayRange}
                                        value="less"
                                        disabled={this.state.showSearchResults || this.state.showNameFilter || this.state.showVinFilter || this.state.range === "custom"}
                                    >
                                        ←
                                    </Button>
                                    <Button
                                        variant="outline-secondary"
                                        onClick={this.handleDisplayRange}
                                        active={moment(this.state.selectedDate).isSame(this.state.today, 'day')}
                                        value="today"
                                        disabled={this.state.showSearchResults || this.state.showNameFilter || this.state.showVinFilter || this.state.range === "custom"}
                                    >
                                        Today
                                    </Button>
                                    <Button
                                        variant="outline-secondary"
                                        onClick={this.handleDisplayRange}
                                        value="more"
                                        disabled={this.state.showSearchResults || this.state.showNameFilter || this.state.showVinFilter || this.state.range === "custom"}
                                    >
                                        →
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </div>
                    </div>

                    {/* Overview Dashboard */}
                    <div className="overview-cards">
                        <div className="overview-card">
                            <div className="number">{this.formatCurrency(totalAmount)}</div>
                            <div className="label">Total Invoiced</div>
                        </div>
                        <div className="overview-card">
                            <div className="number">{this.formatCurrency(totalPaid)}</div>
                            <div className="label">Total Paid</div>
                        </div>
                        <div className="overview-card pending">
                            <div className="number">{this.formatCurrency(totalPending)}</div>
                            <div className="label">Pending Payment</div>
                        </div>
                        {this.props.userType === "installer" && (
                            <div className="overview-card">
                                <div className="number">{this.formatCurrency(totalEarned)}</div>
                                <div className="label">Total Earned</div>
                            </div>
                        )}
                    </div>

                    {/* Search and Filter Controls */}
                    <div className="filters-section">
                        <div className="search-controls">
                            {this.renderInvoiceSearch()}
                            {this.renderNameSearch()}
                            {this.renderVinSearch()}
                        </div>
                        <div className="filter-controls">
                            <div className="filter-group">
                                <select
                                    className="form-control"
                                    name="filterOption"
                                    value={this.state.selectedOption}
                                    onChange={this.handleOptionChange}
                                >
                                    {this.state.options.map((option, idx) => (
                                        <option key={idx} value={option}>{option}</option>
                                    ))}
                                </select>
                            </div>
                            {this.props.userType === "installer" && (
                                <div className="filter-group">
                                    <select
                                        className="form-control"
                                        name="filterType"
                                        value={this.state.selectedType}
                                        onChange={this.handleTypeChange}
                                    >
                                        {this.state.types.map((type, idx) => (
                                            <option key={idx} value={type}>{type}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {/* Location filter: only show when viewing all locations (global selector) */}
                            {isMultiLocation(this.props.locations) && this.props.userType === "installer" && isAllLocations(this.props.selectedLocationId) && (
                                <div className="filter-group">
                                    <select
                                        className="form-control"
                                        value={this.state.financialsLocationId || 'all'}
                                        onChange={(e) => this.handleFinancialsLocationChange(e.target.value === 'all' ? 'all' : e.target.value)}
                                    >
                                        <option value="all">All Locations</option>
                                        {[...this.props.locations].sort((a, b) => getLocationName(a).localeCompare(getLocationName(b))).map(loc => (
                                            <option key={loc.location_id} value={loc.location_id}>
                                                {getLocationName(loc)}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {this.props.userType === "installer" && this.state.dealerGroups.length > 0 && (
                                <div className="filter-group">
                                    <select
                                        className="form-control"
                                        value={
                                            this.state.selectedDealerGroupDealerId !== "all"
                                                ? `dealer:${this.state.selectedDealerGroupId}:${this.state.selectedDealerGroupDealerId}`
                                                : this.state.selectedDealerGroupId !== "all"
                                                    ? `group:${this.state.selectedDealerGroupId}`
                                                    : "all"
                                        }
                                        onChange={this.handleDealerGroupFilterChange}
                                    >
                                        <option value="all">All Dealer Groups</option>
                                        {this.state.dealerGroups.map(dg => (
                                            <React.Fragment key={dg.group_id}>
                                                {dg.dealerships.length > 1 && (
                                                    <option value={`group:${dg.group_id}`}>
                                                        {dg.group_name}
                                                    </option>
                                                )}
                                                {dg.dealerships.map(d => (
                                                    <option key={d.dealer_id} value={`dealer:${dg.group_id}:${d.dealer_id}`}>
                                                        {dg.dealerships.length > 1 ? `  ${dg.group_name} - ${d.dealer_name}` : `${dg.group_name} - ${d.dealer_name}`}
                                                    </option>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {this.props.userType === "dealer" && ScopeService.isDealerGroupUser() && (
                                <>
                                    {/* Dealer filter: only show when viewing all dealerships (global selector) */}
                                    {isAllDealerships(this.props.selectedDealerId) && (
                                        <div className="filter-group">
                                            <select
                                                className="form-control"
                                                value={this.state.selectedDealerId}
                                                onChange={this.handleDealerFilterChange}
                                            >
                                                <option value="all">All Dealerships</option>
                                                {this.state.dealerships.map(d => (
                                                    <option key={d.dealer_id} value={d.dealer_id}>
                                                        {d.dealer_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                    <div className="filter-group">
                                        <select
                                            className="form-control"
                                            value={this.state.selectedInstallerId}
                                            onChange={this.handleInstallerFilterChange}
                                        >
                                            <option value="all">All Installers</option>
                                            {this.state.installers.map(name => (
                                                <option key={name} value={name}>
                                                    {name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

{/* Action Buttons */}
<div className="action-buttons">
    <div className="label">Quick Actions:</div>
    {this.props.userType === "dealer" ? (
        <>
            {!this.state.batchCheckMode ? (
                <>
                    <button
                        className="action-btn download-btn"
                        onClick={this.handleDealerMonthlyStatement}
                        disabled={monthlyCount === 0 || loading}
                    >
                        {loading ? (
                            <><i className="fa-sharp fa-regular fa-spinner fa-spin mr-1"></i> Generating...</>
                        ) : (
                            <><i className="fa-sharp fa-regular fa-file-lines mr-1"></i> Download Statement ({monthlyCount})</>
                        )}
                    </button>
                    {this.state.selectedInstallerId !== "all" ? (
                        <button
                            className="action-btn"
                            onClick={this.handleBatchCheckMode}
                            style={{ backgroundColor: 'var(--color-success-dark)', borderColor: 'var(--color-success-dark)', color: 'white' }}
                        >
                            <><i className="fa-sharp fa-regular fa-file-lines mr-1"></i> Batch Invoices</>
                        </button>
                    ) : (
                        <button
                            className="action-btn"
                            disabled
                            title="Select a specialist to enable batch mode"
                            style={{ opacity: 0.5 }}
                        >
                            <><i className="fa-sharp fa-regular fa-file-lines mr-1"></i> Batch Invoices</>
                        </button>
                    )}
                    <button className="action-btn" onClick={this.handleOpen}>
                        <><i className="fa-sharp fa-regular fa-file-arrow-down mr-1"></i> Download Jobvious W-9</>
                    </button>
                </>
            ) : (
                <>
                    <button
                        className="action-btn"
                        onClick={this.handleOpenBatchCheck}
                        disabled={this.state.selectedInvoices.length === 0}
                        style={{ backgroundColor: 'var(--color-brand-teal)', borderColor: 'var(--color-brand-teal)', color: 'white' }}
                    >
                        <><i className="fa-sharp fa-regular fa-money-check mr-1"></i> Enter Payment Details ({this.state.selectedInvoices.length} selected)</>
                    </button>
                    <button
                        className="action-btn"
                        onClick={this.handleExitBatchMode}
                        style={{ backgroundColor: 'var(--color-text-secondary)', borderColor: 'var(--color-text-secondary)', color: 'white' }}
                    >
                        <><i className="fa-sharp fa-regular fa-xmark mr-1"></i> Cancel Batch Mode</>
                    </button>
                </>
            )}
        </>
    ) : (
        <>
            {/* Show batch mode buttons when active, otherwise show normal buttons */}
            {!this.state.batchCheckMode ? (
                <>
                    <button 
                        className="action-btn download-btn" 
                        onClick={this.handleDownloadCSV}
                        disabled={displayArray.length === 0}
                    >
                        <><i className="fa-sharp fa-regular fa-file-csv mr-1"></i> Download CSV</>
                    </button>

                    <button 
                        className="action-btn bookkeeper-btn" 
                        onClick={this.handleGenerateBookkeeperReport}
                        disabled={loading || displayArray.length === 0}
                        style={{ backgroundColor: 'var(--color-purple, #6f42c1)', borderColor: 'var(--color-purple, #6f42c1)', color: 'white' }}
                    >
                        {loading ? (
                            <><i className="fa-sharp fa-regular fa-spinner fa-spin mr-1"></i> Generating...</>
                        ) : (
                            <><i className="fa-sharp fa-regular fa-chart-line mr-1"></i> Bookkeeper Report</>
                        )}
                    </button>

                    {this.state.canAccessStripeDashboard && (
                        <button 
                            className="action-btn" 
                            onClick={this.handleStripeDashboard}
                            disabled={this.state.stripeDashboardLoading}
                            style={{ backgroundColor: '#635bff', borderColor: '#635bff', color: 'white' }}
                        >
                            {this.state.stripeDashboardLoading ? (
                                <><i className="fa-sharp fa-regular fa-spinner fa-spin mr-1"></i> Opening...</>
                            ) : (
                                <><i className="fa-sharp fa-regular fa-credit-card mr-1"></i> Stripe Dashboard</>
                            )}
                        </button>
                    )}

                    {this.hasUnsettledDeposits(displayArray) && (
                        <button 
                            className="action-btn" 
                            onClick={this.handleShowDepositInfo}
                            style={{ backgroundColor: 'var(--color-warning-dark)', borderColor: 'var(--color-warning-dark)', color: 'white' }}
                        >
                            <><i className="fa-sharp fa-regular fa-coins mr-1"></i> Manage Deposits ({displayArray.filter(item => item.isDeposit && item.currentState === 'Invoiced').length})</>
                        </button>
                    )}

                    {/* QuickBooks Sync (Online mode only) */}
                    {this.state.qboConnected && this.props.company?.qb_mode === 'online' && isInstallerAdmin(this.props.user) && (() => {
                        const unsyncedCount = this.getUnsyncedPayments(displayArray).length;
                        const hasErrors = displayArray.some(r => r.qbo_sync_error);
                        return unsyncedCount > 0 || hasErrors ? (
                            <button
                                className="action-btn"
                                onClick={() => this.handleQboSync(displayArray)}
                                disabled={this.state.qboSyncing}
                                style={{
                                    backgroundColor: hasErrors ? 'var(--color-danger)' : 'var(--color-success-dark)',
                                    borderColor: hasErrors ? 'var(--color-danger)' : 'var(--color-success-dark)',
                                    color: 'white'
                                }}
                            >
                                {this.state.qboSyncing
                                    ? <><i className="fa-sharp fa-regular fa-spinner fa-spin mr-1"></i> Syncing...</>
                                    : hasErrors
                                        ? <><i className="fa-sharp fa-regular fa-arrows-rotate mr-1"></i> Retry QuickBooks Sync ({unsyncedCount})</>
                                        : <><i className="fa-sharp fa-regular fa-arrows-rotate mr-1"></i> Sync to QuickBooks ({unsyncedCount})</>
                                }
                            </button>
                        ) : (
                            <span className="action-btn" style={{
                                backgroundColor: 'var(--color-success-light)',
                                borderColor: 'var(--color-success-light)',
                                color: 'var(--color-success-dark)',
                                cursor: 'default'
                            }}>
                                <i className="fa-sharp fa-regular fa-check mr-1"></i> QuickBooks Synced
                            </span>
                        );
                    })()}

                    {/* Batch Check Payment Entry Button — requires a dealer group or dealership selected */}
                    {this.state.selectedDealerGroupId !== "all" ? (
                        <button
                            className="action-btn"
                            onClick={this.handleBatchCheckMode}
                            style={{ backgroundColor: 'var(--color-success-dark)', borderColor: 'var(--color-success-dark)', color: 'white' }}
                        >
                            <><i className="fa-sharp fa-regular fa-money-check mr-1"></i> Process Dealer Checks</>
                        </button>
                    ) : (
                        <button
                            className="action-btn"
                            disabled
                            title="Select a dealer group to enable batch mode"
                            style={{ opacity: 0.5 }}
                        >
                            <><i className="fa-sharp fa-regular fa-money-check mr-1"></i> Process Dealer Checks</>
                        </button>
                    )}
                </>
            ) : (
                <>
                    {/* Batch Mode Active - Show batch-specific buttons */}
                    <button 
                        className="action-btn" 
                        onClick={this.handleOpenBatchCheck}
                        disabled={this.state.selectedInvoices.length === 0}
                        style={{ backgroundColor: 'var(--color-brand-teal)', borderColor: 'var(--color-brand-teal)', color: 'white' }}
                    >
                        <><i className="fa-sharp fa-regular fa-money-check mr-1"></i> Enter Check Payment ({this.state.selectedInvoices.length} selected)</>
                    </button>
                    <button 
                        className="action-btn" 
                        onClick={this.handleExitBatchMode}
                        style={{ backgroundColor: 'var(--color-text-secondary)', borderColor: 'var(--color-text-secondary)', color: 'white' }}
                    >
                        <><i className="fa-sharp fa-regular fa-xmark mr-1"></i> Cancel Batch Mode</>
                    </button>
                </>
            )}
        </>
    )}
</div>

                    {/* Filter Status Messages */}
                    {this.state.showVinFilter && (
                        <div className={`alert ${this.state.filteredByVin.length === 0 ? 'alert-warning' : 'alert-info'}`}>
                            {this.state.filteredByVin.length === 0 ? (
                                <>No invoices found for VIN "{this.state.vinSearchTerm}".</>
                            ) : (
                                <>
                                    Found {this.state.filteredByVin.length} invoice{this.state.filteredByVin.length !== 1 ? 's' : ''} for VIN "{this.state.vinSearchTerm}".
                                </>
                            )}
                            <button className="btn btn-link p-0 ml-2" onClick={this.clearVinFilter}>Clear Filter</button>
                        </div>
                    )}

                    {this.state.showNameFilter && (
                        <div className={`alert ${this.state.filteredByName.length === 0 ? 'alert-warning' : 'alert-info'}`}>
                            {this.state.filteredByName.length === 0 ? (
                                <>No invoices found for name "{this.state.nameSearchTerm}".</>
                            ) : (
                                <>
                                    Found {this.state.filteredByName.length} invoice{this.state.filteredByName.length !== 1 ? 's' : ''} for name "{this.state.nameSearchTerm}".
                                </>
                            )}
                            <button className="btn btn-link p-0 ml-2" onClick={this.clearNameFilter}>Clear Filter</button>
                        </div>
                    )}

                    {this.state.showSearchResults && (
                        <div className={`alert ${this.state.filteredTransactions.length === 0 ? 'alert-warning' : 'alert-info'}`}>
                            {this.state.filteredTransactions.length === 0 ? (
                                <>No invoices found matching "{this.state.searchTerm}".</>
                            ) : (
                                <>
                                    Found {this.state.filteredTransactions.length} invoice{this.state.filteredTransactions.length !== 1 ? 's' : ''} matching "{this.state.searchTerm}".
                                </>
                            )}
                            <button className="btn btn-link p-0 ml-2" onClick={this.clearSearch}>Clear Search</button>
                        </div>
                    )}

                    {/* Data Table */}
                    <div className="table-container jv-bt-table">
<BootstrapTable
    keyField='invoiceId'
    data={requests}
    columns={columns}
    rowClasses={rowClasses}
    expandRow={expandRow}
    defaultSorted={[{ dataField: 'invoiceDate', order: 'desc' }]}
    key={this.state.selectedInvoices.length + '-' + this.state.expandedRows.length + '-' + requests.length}
/>                    </div>
                </div>

                {/* Modals */}
                <ViewJob
                    show={this.state.showDetails}
                    onHide={this.addCustomClose}            
                    request={this.state.selectedRequestimate}
                    services={this.state.services}
                    notes={this.state.notes}
                />
                <AddPO
                    show={this.state.showPO}
                    onClose={this.closePO}
                    type={this.props.userType}
                    requestId={this.state.requestId}
                    invoiceId={this.state.invoiceId}
                    purchaseOrder={this.state.poNumber}
                    onPO={this.handleAddPO}
                    onInvoice={this.handleInvoice}
                />
                <Modal show={this.state.showReviseChoice} onHide={this.closeReviseChoice} centered>
                    <Modal.Header closeButton={!this.state.reviseBusy}>
                        <Modal.Title style={{ fontSize: '1.1rem' }}>Void Invoice</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p style={{ marginBottom: '16px' }}>
                            Voiding cancels this invoice in Stripe and QuickBooks and sends a
                            cancellation notice to the dealer. The voided invoice is kept on record
                            (visible under the <strong>Voided</strong> filter) and removed from your
                            active lists. How would you like to proceed?
                        </p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <button
                                type="button"
                                className="revise-choice-btn"
                                disabled={this.state.reviseBusy}
                                onClick={this.handleVoidAndReplace}
                            >
                                <i className="fa-sharp fa-regular fa-pen-to-square mr-2"></i>
                                <span>
                                    <strong>Void &amp; Replace</strong>
                                    <small>Void this invoice and edit the job to generate a new one.</small>
                                </span>
                            </button>
                            <button
                                type="button"
                                className="revise-choice-btn"
                                disabled={this.state.reviseBusy}
                                onClick={this.handleVoidOnly}
                            >
                                <i className="fa-sharp fa-regular fa-ban mr-2"></i>
                                <span>
                                    <strong>Void Only</strong>
                                    <small>Void this invoice with no replacement. The job is kept as a voided record.</small>
                                </span>
                            </button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={this.closeReviseChoice} disabled={this.state.reviseBusy}>
                            Cancel
                        </Button>
                        {this.state.reviseBusy && (
                            <span style={{ color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>
                                <i className="fa-sharp fa-regular fa-spinner fa-spin mr-1"></i> Voiding…
                            </span>
                        )}
                    </Modal.Footer>
                </Modal>
                <BatchCheckPayment
    show={this.state.showBatchCheck}
    selectedInvoices={this.state.selectedInvoices}
    onSubmit={this.props.userType === "dealer"
        ? this.handleBatchLinkSubmit
        : this.handleBatchCheckSubmit}
    onClose={this.handleCloseBatchCheck}
    mode={this.props.userType === "dealer" ? "link" : "settle"}
/>

                <style>{`
                    .revise-choice-btn {
                        display: flex;
                        align-items: flex-start;
                        gap: 12px;
                        width: 100%;
                        text-align: left;
                        padding: 14px 16px;
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        background: var(--color-bg-card);
                        cursor: pointer;
                        transition: border-color 0.15s, background 0.15s;
                    }
                    .revise-choice-btn:hover:not(:disabled) {
                        border-color: var(--color-brand-teal);
                        background: var(--color-bg-panel);
                    }
                    .revise-choice-btn:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                    .revise-choice-btn i {
                        font-size: 1.1rem;
                        color: var(--color-brand-teal);
                        margin-top: 2px;
                    }
                    .revise-choice-btn span {
                        display: flex;
                        flex-direction: column;
                    }
                    .revise-choice-btn small {
                        color: var(--color-text-muted);
                        margin-top: 2px;
                    }

                    .financials-container {
                        max-width: 1400px;
                        margin: 0 auto;
                        padding: 24px;
                        background: var(--color-bg-panel);
                        min-height: 100vh;
                    }

                    .financials-container.mobile {
                        padding: 16px;
                    }

                    .error-message {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-danger-light);
                        border-radius: 8px;
                        padding: 24px;
                        text-align: center;
                        color: var(--color-danger);
                    }

                    .error-message button {
                        background: var(--color-danger);
                        color: white;
                        border: none;
                        padding: 8px 16px;
                        border-radius: 4px;
                        cursor: pointer;
                        margin-top: 12px;
                    }

                    .financials-header {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        padding: 24px;
                        margin-bottom: 24px;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .mobile .financials-header {
                        padding: 16px;
                        margin-bottom: 16px;
                    }

                    .header-content {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        flex-wrap: wrap;
                        gap: 16px;
                    }

                    .mobile .header-content {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .header-nav {
                        display: flex;
                        align-items: center;
                        gap: 16px;
                        flex-wrap: wrap;
                        width: 100%;
                        justify-content: space-between;
                    }

                    .mobile .header-nav {
                        justify-content: space-between;
                        flex-direction: column;
                        gap: 12px;
                    }

                    .view-toggle {
                        display: flex;
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 6px;
                        overflow: hidden;
                        flex-shrink: 0;
                    }

                    .view-toggle button {
                        background: var(--color-bg-card);
                        border: none;
                        padding: 8px 16px;
                        font-size: 13px;
                        font-weight: 500;
                        color: var(--color-text-secondary);
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .view-toggle button:hover:not(:disabled) {
                        background: var(--color-bg-hover);
                    }

                    .view-toggle button.active {
                        background: var(--color-brand-teal);
                        color: white;
                    }

                    .view-toggle button:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }

                    .date-display-area {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        min-height: 40px;
                        gap: 4px;
                    }

                    .custom-date-inputs-inline {
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        padding: 8px 16px;
                        background: var(--color-bg-panel);
                        border: 1px solid var(--color-border);
                        border-radius: 6px;
                        flex-wrap: wrap;
                        justify-content: center;
                    }

                    .date-input-group {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                    }

                    .date-input-group label {
                        font-size: 14px;
                        font-weight: 500;
                        color: var(--color-text-primary);
                        white-space: nowrap;
                    }

                    .date-input-group input[type="date"] {
                        padding: 6px 8px;
                        border: 1px solid var(--color-border-light);
                        border-radius: 4px;
                        font-size: 14px;
                        transition: border-color 0.2s ease;
                    }

                    .date-input-group input[type="date"]:focus {
                        outline: none;
                        border-color: var(--color-brand-teal);
                        box-shadow: 0 0 0 2px rgba(63, 178, 190, 0.1);
                    }

                    .apply-custom-date-btn {
                        background: var(--color-brand-teal);
                        color: white;
                        border: 1px solid var(--color-brand-teal);
                        padding: 6px 16px;
                        border-radius: 4px;
                        font-size: 14px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.2s ease;
                        white-space: nowrap;
                    }

                    .apply-custom-date-btn:hover:not(:disabled) {
                        background: var(--color-brand-teal-dark, #359ca6);
                        border-color: var(--color-brand-teal-dark, #359ca6);
                    }

                    .apply-custom-date-btn:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }

                    .invoice-count-below {
                        font-size: 14px;
                        color: var(--color-text-secondary);
                        font-weight: 500;
                        text-align: center;
                    }

                    .mobile .custom-date-inputs-inline {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 8px;
                        width: 100%;
                    }

                    .mobile .date-input-group {
                        justify-content: space-between;
                    }

                    .mobile .date-input-group input[type="date"] {
                        flex: 1;
                        margin-left: 8px;
                    }

                    .nav-controls {
                        flex-shrink: 0;
                    }

                    .mobile .nav-controls {
                        order: 1;
                    }

                    .date-display {
                        font-size: 16px;
                        font-weight: 500;
                        color: var(--color-text-primary);
                        text-align: center;
                    }

                    .mobile .date-display {
                        text-align: center;
                        padding: 8px 0;
                        order: -1;
                    }

                    .overview-cards {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                        gap: 16px;
                        margin-bottom: 24px;
                    }

                    .mobile .overview-cards {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 12px;
                        margin-bottom: 16px;
                    }

                    .overview-card {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        padding: 20px;
                        text-align: center;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .mobile .overview-card {
                        padding: 16px 12px;
                    }

                    .overview-card .number {
                        font-size: 20px;
                        font-weight: 700;
                        color: var(--color-text-primary);
                        margin-bottom: 4px;
                    }

                    .mobile .overview-card .number {
                        font-size: 16px;
                    }

                    .overview-card .label {
                        font-size: 12px;
                        color: var(--color-text-secondary);
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .overview-card.pending .number {
                        color: var(--color-warning);
                    }

                    .filters-section {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        padding: 20px;
                        margin-bottom: 16px;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    .search-controls {
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        gap: 16px;
                        margin-bottom: 20px;
                    }

                    .mobile .search-controls {
                        grid-template-columns: 1fr;
                        gap: 12px;
                    }

                    .search-group {
                        display: flex;
                        flex-direction: column;
                        gap: 4px;
                    }

                    .search-group label {
                        font-size: 14px;
                        font-weight: 500;
                        color: var(--color-text-primary);
                    }

                    .search-input-group {
                        position: relative;
                        display: flex;
                        align-items: center;
                    }

                    .search-input {
                        width: 100%;
                        padding: 8px 12px;
                        border: 1px solid var(--color-border-light);
                        border-radius: 6px;
                        font-size: 14px;
                        transition: border-color 0.2s ease;
                    }

                    .search-input:focus {
                        outline: none;
                        border-color: var(--color-brand-teal);
                        box-shadow: 0 0 0 2px rgba(63, 178, 190, 0.1);
                    }

                    .clear-search-btn {
                        position: absolute;
                        right: 8px;
                        background: none;
                        border: none;
                        font-size: 18px;
                        color: var(--color-text-secondary);
                        cursor: pointer;
                        padding: 0;
                        width: 20px;
                        height: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .clear-search-btn:hover {
                        color: var(--color-text-primary);
                    }

                    .filter-controls {
                        display: flex;
                        gap: 16px;
                        align-items: center;
                        flex-wrap: wrap;
                    }

                    .mobile .filter-controls {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 12px;
                    }

                    .filter-group {
                        flex: 1;
                        min-width: 150px;
                    }


                    .action-buttons {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        padding: 16px;
                        margin-bottom: 24px;
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        flex-wrap: wrap;
                    }

                    .action-buttons .label {
                        font-size: 14px;
                        font-weight: 500;
                        color: var(--color-text-primary);
                    }

                    .action-btn {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        color: var(--color-text-secondary);
                        padding: 8px 16px;
                        border-radius: 6px;
                        font-size: 13px;
                        font-weight: 500;
                        cursor: pointer;
                        transition: all 0.2s ease;
                    }

                    .action-btn:hover:not(:disabled) {
                        border-color: var(--color-border-light);
                        background: var(--color-bg-hover);
                        transform: translateY(-1px);
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    }

                    .action-btn:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }

                    .download-btn {
                        background: var(--color-brand-teal) !important;
                        color: white !important;
                        border-color: var(--color-brand-teal) !important;
                    }

                    .download-btn:hover:not(:disabled) {
                        background: var(--color-brand-teal-dark, #359ca6) !important;
                        border-color: var(--color-brand-teal-dark, #359ca6) !important;
                        color: white !important;
                    }

                    .alert {
                        padding: 12px 16px;
                        border-radius: 6px;
                        margin-bottom: 16px;
                        font-size: 14px;
                    }

                    .alert-info {
                        background-color: var(--color-info-light);
                        border: 1px solid var(--color-info);
                        color: var(--color-info);
                    }

                    .alert-warning {
                        background-color: var(--color-warning-light);
                        border: 1px solid var(--color-warning);
                        color: var(--color-warning-dark);
                    }

                    .table-container {
                        background: var(--color-bg-card);
                        border: 1px solid var(--color-border);
                        border-radius: 8px;
                        overflow: hidden;
                        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    }

                    /* Custom Bootstrap Table Styling */
                    .table-container .react-bootstrap-table {
                        margin: 0;
                    }

                    .table-container .react-bootstrap-table table {
                        margin: 0;
                        border-collapse: separate;
                        border-spacing: 0;
                    }

                    .table-container .react-bootstrap-table table th {
                        background: var(--color-bg-table-header);
                        border-bottom: 2px solid var(--color-border);
                        border-top: none;
                        padding: 12px 16px;
                        font-weight: 600;
                        color: var(--color-gray-500);
                        font-size: 12px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .table-container .react-bootstrap-table table td {
                        padding: 12px 16px;
                        border-bottom: 1px solid var(--color-border-light);
                        border-top: none;
                        vertical-align: middle;
                        border-left: 3px solid transparent;
                        transition: all 0.2s ease;
                    }

                    /* Row styling with left border colors matching calendar cards */
                    .table-container .react-bootstrap-table table tbody tr {
                        transition: all 0.2s ease;
                    }

                    .table-container .react-bootstrap-table table tbody tr:hover {
                        background-color: var(--color-bg-hover) !important;
                        transform: translateY(-1px);
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    }

                    .table-container .react-bootstrap-table table tbody tr:hover td:first-child {
                        border-left-width: 4px;
                    }

                    /* Source type indicators - dealer (orange) vs retail/installer (blue) */
                    .table-container .react-bootstrap-table table tbody tr.source-dealer td:first-child {
                        border-left: 3px solid var(--color-brand-orange);
                    }
                    .table-container .react-bootstrap-table table tbody tr.source-retail td:first-child {
                        border-left: 3px solid var(--color-brand-blue);
                    }

/* bookkeeper button hover */
.bookkeeper-btn:hover:not(:disabled) {
    background: var(--color-purple-dark, #5a32a3) !important;
    border-color: var(--color-purple-dark, #5a32a3) !important;
    color: white !important;
}

/* Split Payment Styles */
.split-badge {
    display: inline-block;
    background: var(--color-purple, #8b5cf6);
    color: white;
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    margin-left: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.split-payment-state {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.expand-icon {
    font-size: 10px;
    color: var(--color-text-secondary);
    margin-left: 4px;
    transition: transform 0.2s ease;
}

.split-payment-state:hover .expand-icon {
    color: var(--color-text-primary);
}

.split-payment-details {
    background: var(--color-bg-panel);
    padding: 16px 20px;
    border-left: 4px solid var(--color-purple, #8b5cf6);
    margin: 0;
}

.split-payment-header {
    margin-bottom: 12px;
    color: var(--color-text-primary);
    font-size: 14px;
}

.split-payment-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    background: var(--color-bg-card);
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.split-payment-table th {
    background: var(--color-bg-panel);
    padding: 10px 12px;
    text-align: left;
    font-weight: 600;
    color: var(--color-text-secondary);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid var(--color-border);
}

.split-payment-table td {
    padding: 10px 12px;
    border-bottom: 1px solid var(--color-bg-panel);
    color: var(--color-text-primary);
}

.split-payment-table tr:last-child td {
    border-bottom: none;
}

.split-row:hover {
    background: var(--color-bg-panel);
}

.method-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 500;
}

.method-terminal {
    background: var(--color-info-light);
    color: var(--color-info);
}

.method-cash {
    background: var(--color-success-light);
    color: var(--color-success-dark);
}

.method-check {
    background: var(--color-warning-light);
    color: var(--color-warning-dark);
}

.method-online {
    background: var(--color-purple-light, #f3e8ff);
    color: var(--color-purple, #7c3aed);
}

.method-unknown {
    background: var(--color-bg-panel);
    color: var(--color-text-secondary);
}

.status-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 500;
}

.status-paid {
    background: var(--color-success-light);
    color: var(--color-success-dark);
}

.status-pending {
    background: var(--color-warning-light);
    color: var(--color-warning-dark);
}

.status-invoiced {
    background: var(--color-info-light);
    color: var(--color-info);
}

/* Expanded row styling in table */
.table-container .react-bootstrap-table table tbody tr.expand-row {
    background: var(--color-bg-panel) !important;
}

.table-container .react-bootstrap-table table tbody tr.expand-row td {
    padding: 0;
    border-left: none;
}


                    /* Responsive table */
                    @media (max-width: 768px) {
                        .financials-container {
                            padding: 12px;
                        }
                        
                        .overview-cards {
                            grid-template-columns: 1fr;
                            gap: 8px;
                        }
                        
                        .search-controls {
                            grid-template-columns: 1fr;
                        }
                        
                        .filter-controls {
                            flex-direction: column;
                            align-items: stretch;
                        }
                        
                        .action-buttons {
                            flex-direction: column;
                            align-items: stretch;
                        }
                        
                        .action-btn {
                            text-align: center;
                        }
                    }
                `}</style>
            </React.Fragment>
        );
    }
}
 
export default Financials;